// source: wt/svc/customer/user_team.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_api_annotations_pb = require('../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var wt_svc_shared_shared_pb = require('../../../wt/svc/shared/shared_pb.js');
goog.object.extend(proto, wt_svc_shared_shared_pb);
var wisetime_type_data_retention_pb = require('../../../wisetime/type/data_retention_pb.js');
goog.object.extend(proto, wisetime_type_data_retention_pb);
var wisetime_type_seat_seat_policy_pb = require('../../../wisetime/type/seat/seat_policy_pb.js');
goog.object.extend(proto, wisetime_type_seat_seat_policy_pb);
var wisetime_type_site_preferences_pb = require('../../../wisetime/type/site_preferences_pb.js');
goog.object.extend(proto, wisetime_type_site_preferences_pb);
goog.exportSymbol('proto.pi_customer_public.AcceptTeamJoinInviteRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.AcceptTeamJoinInviteResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ActivateMembershipRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.ActivateMembershipResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ActivateMembershipStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.ApproveRequestToJoinTeamRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.ApproveRequestToJoinTeamResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ApproveRequestToJoinTeamStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.BusinessRole', null, global);
goog.exportSymbol('proto.pi_customer_public.CancelInvitationRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.CancelInvitationResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.CancelInvitationStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.CancelMembershipRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.CancelMembershipResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.CancelMembershipStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.CancelMyRequestToJoinTeamRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.CancelMyRequestToJoinTeamResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.CancelMyRequestToJoinTeamStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.CreateBusinessRoleRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.CreateBusinessRoleResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.CreateTeamRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.CreateTeamResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.CreateTeamStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.DeclineRequestToJoinTeamRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.DeclineRequestToJoinTeamResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.DeclineRequestToJoinTeamStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.DeleteBusinessRoleRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.DeleteBusinessRoleResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.DeleteTeamRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.DeleteTeamResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ForgetTeamMemberRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.ForgetTeamMemberResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ForgetTeamMemberStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.ForgottenStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.GetMyTeamsRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.GetMyTeamsResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.GetTeamRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.GetTeamResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.IncludeActivityDefault', null, global);
goog.exportSymbol('proto.pi_customer_public.InviteUsersRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.InviteUsersResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.InviteUsersStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.InvokeRightToBeForgottenRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.InvokeRightToBeForgottenResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ListBusinessRolesRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.ListBusinessRolesResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ListTeamInvitationsRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.ListTeamInvitationsResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ListTeamJoinRequestsRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.ListTeamJoinRequestsResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ListTeamMembershipsRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.ListTeamMembershipsResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.Membership', null, global);
goog.exportSymbol('proto.pi_customer_public.MembershipStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.MyTeam', null, global);
goog.exportSymbol('proto.pi_customer_public.RequestToJoinTeamRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.RequestToJoinTeamResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.RequestToJoinTeamResult', null, global);
goog.exportSymbol('proto.pi_customer_public.RequestToJoinTeamStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.ResendInvitationRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.ResendInvitationResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.ResendRequestToJoinStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.ResendRequestToJoinTeamRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.ResendRequestToJoinTeamResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.SetTeamRoundingPreferenceRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.SetTeamRoundingPreferenceResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.SubscriberInfo', null, global);
goog.exportSymbol('proto.pi_customer_public.SubscriberInfo.PaymentMethod', null, global);
goog.exportSymbol('proto.pi_customer_public.SuggestTeamsRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.SuggestTeamsResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.Team', null, global);
goog.exportSymbol('proto.pi_customer_public.TeamDeleteReason', null, global);
goog.exportSymbol('proto.pi_customer_public.TeamJoinInviteItem', null, global);
goog.exportSymbol('proto.pi_customer_public.TeamJoinInvitee', null, global);
goog.exportSymbol('proto.pi_customer_public.TeamJoinRequestRecord', null, global);
goog.exportSymbol('proto.pi_customer_public.TeamJoinStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.TeamJoinUserInfo', null, global);
goog.exportSymbol('proto.pi_customer_public.TeamProto', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateAuthorityRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateAuthorityResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateAuthorityStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateBusinessRoleRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateBusinessRoleResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateTeamMembershipRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateTeamMembershipResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateTeamNameRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateTeamNameResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateTeamNameStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateTeamRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateTeamResponse', null, global);
goog.exportSymbol('proto.pi_customer_public.UpdateTeamStatus', null, global);
goog.exportSymbol('proto.pi_customer_public.UploadTeamLogoRequest', null, global);
goog.exportSymbol('proto.pi_customer_public.UploadTeamLogoResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.CreateTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.CreateTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.CreateTeamRequest.displayName = 'proto.pi_customer_public.CreateTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.CreateTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.CreateTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.CreateTeamResponse.displayName = 'proto.pi_customer_public.CreateTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.GetTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.GetTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.GetTeamRequest.displayName = 'proto.pi_customer_public.GetTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.GetTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.GetTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.GetTeamResponse.displayName = 'proto.pi_customer_public.GetTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.TeamProto = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.TeamProto, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.TeamProto.displayName = 'proto.pi_customer_public.TeamProto';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.SubscriberInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.SubscriberInfo.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.SubscriberInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.SubscriberInfo.displayName = 'proto.pi_customer_public.SubscriberInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.GetMyTeamsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.GetMyTeamsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.GetMyTeamsRequest.displayName = 'proto.pi_customer_public.GetMyTeamsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.GetMyTeamsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.GetMyTeamsResponse.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.GetMyTeamsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.GetMyTeamsResponse.displayName = 'proto.pi_customer_public.GetMyTeamsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.MyTeam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.MyTeam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.MyTeam.displayName = 'proto.pi_customer_public.MyTeam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UpdateTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UpdateTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UpdateTeamRequest.displayName = 'proto.pi_customer_public.UpdateTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UpdateTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UpdateTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UpdateTeamResponse.displayName = 'proto.pi_customer_public.UpdateTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UpdateTeamNameRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UpdateTeamNameRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UpdateTeamNameRequest.displayName = 'proto.pi_customer_public.UpdateTeamNameRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UpdateTeamNameResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UpdateTeamNameResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UpdateTeamNameResponse.displayName = 'proto.pi_customer_public.UpdateTeamNameResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UploadTeamLogoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UploadTeamLogoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UploadTeamLogoRequest.displayName = 'proto.pi_customer_public.UploadTeamLogoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UploadTeamLogoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UploadTeamLogoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UploadTeamLogoResponse.displayName = 'proto.pi_customer_public.UploadTeamLogoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.SetTeamRoundingPreferenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.SetTeamRoundingPreferenceRequest.displayName = 'proto.pi_customer_public.SetTeamRoundingPreferenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.SetTeamRoundingPreferenceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.SetTeamRoundingPreferenceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.SetTeamRoundingPreferenceResponse.displayName = 'proto.pi_customer_public.SetTeamRoundingPreferenceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.displayName = 'proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse.displayName = 'proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.DeleteTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.DeleteTeamRequest.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.DeleteTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.DeleteTeamRequest.displayName = 'proto.pi_customer_public.DeleteTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.DeleteTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.DeleteTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.DeleteTeamResponse.displayName = 'proto.pi_customer_public.DeleteTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ListTeamInvitationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ListTeamInvitationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ListTeamInvitationsRequest.displayName = 'proto.pi_customer_public.ListTeamInvitationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ListTeamInvitationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.ListTeamInvitationsResponse.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.ListTeamInvitationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ListTeamInvitationsResponse.displayName = 'proto.pi_customer_public.ListTeamInvitationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.TeamJoinInviteItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.TeamJoinInviteItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.TeamJoinInviteItem.displayName = 'proto.pi_customer_public.TeamJoinInviteItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.InviteUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.InviteUsersRequest.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.InviteUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.InviteUsersRequest.displayName = 'proto.pi_customer_public.InviteUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.TeamJoinInvitee = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.TeamJoinInvitee, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.TeamJoinInvitee.displayName = 'proto.pi_customer_public.TeamJoinInvitee';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.InviteUsersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.InviteUsersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.InviteUsersResponse.displayName = 'proto.pi_customer_public.InviteUsersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.AcceptTeamJoinInviteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.AcceptTeamJoinInviteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.AcceptTeamJoinInviteRequest.displayName = 'proto.pi_customer_public.AcceptTeamJoinInviteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.AcceptTeamJoinInviteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.AcceptTeamJoinInviteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.AcceptTeamJoinInviteResponse.displayName = 'proto.pi_customer_public.AcceptTeamJoinInviteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ResendInvitationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ResendInvitationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ResendInvitationRequest.displayName = 'proto.pi_customer_public.ResendInvitationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ResendInvitationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ResendInvitationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ResendInvitationResponse.displayName = 'proto.pi_customer_public.ResendInvitationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.CancelInvitationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.CancelInvitationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.CancelInvitationRequest.displayName = 'proto.pi_customer_public.CancelInvitationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.CancelInvitationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.CancelInvitationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.CancelInvitationResponse.displayName = 'proto.pi_customer_public.CancelInvitationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.SuggestTeamsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.SuggestTeamsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.SuggestTeamsRequest.displayName = 'proto.pi_customer_public.SuggestTeamsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.SuggestTeamsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.SuggestTeamsResponse.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.SuggestTeamsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.SuggestTeamsResponse.displayName = 'proto.pi_customer_public.SuggestTeamsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.RequestToJoinTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.RequestToJoinTeamRequest.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.RequestToJoinTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.RequestToJoinTeamRequest.displayName = 'proto.pi_customer_public.RequestToJoinTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.RequestToJoinTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.RequestToJoinTeamResponse.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.RequestToJoinTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.RequestToJoinTeamResponse.displayName = 'proto.pi_customer_public.RequestToJoinTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.RequestToJoinTeamResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.RequestToJoinTeamResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.RequestToJoinTeamResult.displayName = 'proto.pi_customer_public.RequestToJoinTeamResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest.displayName = 'proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.displayName = 'proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ResendRequestToJoinTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ResendRequestToJoinTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ResendRequestToJoinTeamRequest.displayName = 'proto.pi_customer_public.ResendRequestToJoinTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ResendRequestToJoinTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ResendRequestToJoinTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ResendRequestToJoinTeamResponse.displayName = 'proto.pi_customer_public.ResendRequestToJoinTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.TeamJoinRequestRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.TeamJoinRequestRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.TeamJoinRequestRecord.displayName = 'proto.pi_customer_public.TeamJoinRequestRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.TeamJoinUserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.TeamJoinUserInfo.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.TeamJoinUserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.TeamJoinUserInfo.displayName = 'proto.pi_customer_public.TeamJoinUserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.Team = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.Team, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.Team.displayName = 'proto.pi_customer_public.Team';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.CancelMyRequestToJoinTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.displayName = 'proto.pi_customer_public.CancelMyRequestToJoinTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.CancelMyRequestToJoinTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.displayName = 'proto.pi_customer_public.CancelMyRequestToJoinTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ListTeamJoinRequestsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ListTeamJoinRequestsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ListTeamJoinRequestsRequest.displayName = 'proto.pi_customer_public.ListTeamJoinRequestsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.ListTeamJoinRequestsResponse.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.ListTeamJoinRequestsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ListTeamJoinRequestsResponse.displayName = 'proto.pi_customer_public.ListTeamJoinRequestsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ApproveRequestToJoinTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ApproveRequestToJoinTeamRequest.displayName = 'proto.pi_customer_public.ApproveRequestToJoinTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ApproveRequestToJoinTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ApproveRequestToJoinTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ApproveRequestToJoinTeamResponse.displayName = 'proto.pi_customer_public.ApproveRequestToJoinTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.DeclineRequestToJoinTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.DeclineRequestToJoinTeamRequest.displayName = 'proto.pi_customer_public.DeclineRequestToJoinTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.DeclineRequestToJoinTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.DeclineRequestToJoinTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.DeclineRequestToJoinTeamResponse.displayName = 'proto.pi_customer_public.DeclineRequestToJoinTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ListTeamMembershipsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ListTeamMembershipsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ListTeamMembershipsRequest.displayName = 'proto.pi_customer_public.ListTeamMembershipsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ListTeamMembershipsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.ListTeamMembershipsResponse.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.ListTeamMembershipsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ListTeamMembershipsResponse.displayName = 'proto.pi_customer_public.ListTeamMembershipsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.Membership = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.Membership, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.Membership.displayName = 'proto.pi_customer_public.Membership';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.BusinessRole = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.BusinessRole, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.BusinessRole.displayName = 'proto.pi_customer_public.BusinessRole';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UpdateTeamMembershipRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UpdateTeamMembershipRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UpdateTeamMembershipRequest.displayName = 'proto.pi_customer_public.UpdateTeamMembershipRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UpdateTeamMembershipResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UpdateTeamMembershipResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UpdateTeamMembershipResponse.displayName = 'proto.pi_customer_public.UpdateTeamMembershipResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.CancelMembershipRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.CancelMembershipRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.CancelMembershipRequest.displayName = 'proto.pi_customer_public.CancelMembershipRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.CancelMembershipResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.CancelMembershipResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.CancelMembershipResponse.displayName = 'proto.pi_customer_public.CancelMembershipResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ActivateMembershipRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ActivateMembershipRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ActivateMembershipRequest.displayName = 'proto.pi_customer_public.ActivateMembershipRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ActivateMembershipResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ActivateMembershipResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ActivateMembershipResponse.displayName = 'proto.pi_customer_public.ActivateMembershipResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ForgetTeamMemberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ForgetTeamMemberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ForgetTeamMemberRequest.displayName = 'proto.pi_customer_public.ForgetTeamMemberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ForgetTeamMemberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ForgetTeamMemberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ForgetTeamMemberResponse.displayName = 'proto.pi_customer_public.ForgetTeamMemberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.InvokeRightToBeForgottenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.InvokeRightToBeForgottenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.InvokeRightToBeForgottenRequest.displayName = 'proto.pi_customer_public.InvokeRightToBeForgottenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.InvokeRightToBeForgottenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.InvokeRightToBeForgottenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.InvokeRightToBeForgottenResponse.displayName = 'proto.pi_customer_public.InvokeRightToBeForgottenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UpdateAuthorityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UpdateAuthorityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UpdateAuthorityRequest.displayName = 'proto.pi_customer_public.UpdateAuthorityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UpdateAuthorityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UpdateAuthorityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UpdateAuthorityResponse.displayName = 'proto.pi_customer_public.UpdateAuthorityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ListBusinessRolesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.ListBusinessRolesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ListBusinessRolesRequest.displayName = 'proto.pi_customer_public.ListBusinessRolesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.ListBusinessRolesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pi_customer_public.ListBusinessRolesResponse.repeatedFields_, null);
};
goog.inherits(proto.pi_customer_public.ListBusinessRolesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.ListBusinessRolesResponse.displayName = 'proto.pi_customer_public.ListBusinessRolesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.CreateBusinessRoleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.CreateBusinessRoleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.CreateBusinessRoleRequest.displayName = 'proto.pi_customer_public.CreateBusinessRoleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.CreateBusinessRoleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.CreateBusinessRoleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.CreateBusinessRoleResponse.displayName = 'proto.pi_customer_public.CreateBusinessRoleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UpdateBusinessRoleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UpdateBusinessRoleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UpdateBusinessRoleRequest.displayName = 'proto.pi_customer_public.UpdateBusinessRoleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.UpdateBusinessRoleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.UpdateBusinessRoleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.UpdateBusinessRoleResponse.displayName = 'proto.pi_customer_public.UpdateBusinessRoleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.DeleteBusinessRoleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.DeleteBusinessRoleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.DeleteBusinessRoleRequest.displayName = 'proto.pi_customer_public.DeleteBusinessRoleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pi_customer_public.DeleteBusinessRoleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pi_customer_public.DeleteBusinessRoleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pi_customer_public.DeleteBusinessRoleResponse.displayName = 'proto.pi_customer_public.DeleteBusinessRoleResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.CreateTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.CreateTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.CreateTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CreateTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.CreateTeamRequest}
 */
proto.pi_customer_public.CreateTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.CreateTeamRequest;
  return proto.pi_customer_public.CreateTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.CreateTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.CreateTeamRequest}
 */
proto.pi_customer_public.CreateTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.CreateTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.CreateTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.CreateTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CreateTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.pi_customer_public.CreateTeamRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.CreateTeamRequest} returns this
 */
proto.pi_customer_public.CreateTeamRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.CreateTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.CreateTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.CreateTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CreateTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.CreateTeamResponse}
 */
proto.pi_customer_public.CreateTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.CreateTeamResponse;
  return proto.pi_customer_public.CreateTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.CreateTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.CreateTeamResponse}
 */
proto.pi_customer_public.CreateTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamid(value);
      break;
    case 2:
      var value = /** @type {!proto.pi_customer_public.CreateTeamStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.CreateTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.CreateTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.CreateTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CreateTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string teamId = 1;
 * @return {string}
 */
proto.pi_customer_public.CreateTeamResponse.prototype.getTeamid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.CreateTeamResponse} returns this
 */
proto.pi_customer_public.CreateTeamResponse.prototype.setTeamid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CreateTeamStatus status = 2;
 * @return {!proto.pi_customer_public.CreateTeamStatus}
 */
proto.pi_customer_public.CreateTeamResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.CreateTeamStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pi_customer_public.CreateTeamStatus} value
 * @return {!proto.pi_customer_public.CreateTeamResponse} returns this
 */
proto.pi_customer_public.CreateTeamResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.GetTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.GetTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.GetTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.GetTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.GetTeamRequest}
 */
proto.pi_customer_public.GetTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.GetTeamRequest;
  return proto.pi_customer_public.GetTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.GetTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.GetTeamRequest}
 */
proto.pi_customer_public.GetTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.GetTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.GetTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.GetTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.GetTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.GetTeamRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.GetTeamRequest} returns this
 */
proto.pi_customer_public.GetTeamRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.GetTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.GetTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.GetTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.GetTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    team: (f = msg.getTeam()) && proto.pi_customer_public.TeamProto.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.GetTeamResponse}
 */
proto.pi_customer_public.GetTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.GetTeamResponse;
  return proto.pi_customer_public.GetTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.GetTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.GetTeamResponse}
 */
proto.pi_customer_public.GetTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pi_customer_public.TeamProto;
      reader.readMessage(value,proto.pi_customer_public.TeamProto.deserializeBinaryFromReader);
      msg.setTeam(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.GetTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.GetTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.GetTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.GetTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeam();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pi_customer_public.TeamProto.serializeBinaryToWriter
    );
  }
};


/**
 * optional TeamProto team = 1;
 * @return {?proto.pi_customer_public.TeamProto}
 */
proto.pi_customer_public.GetTeamResponse.prototype.getTeam = function() {
  return /** @type{?proto.pi_customer_public.TeamProto} */ (
    jspb.Message.getWrapperField(this, proto.pi_customer_public.TeamProto, 1));
};


/**
 * @param {?proto.pi_customer_public.TeamProto|undefined} value
 * @return {!proto.pi_customer_public.GetTeamResponse} returns this
*/
proto.pi_customer_public.GetTeamResponse.prototype.setTeam = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pi_customer_public.GetTeamResponse} returns this
 */
proto.pi_customer_public.GetTeamResponse.prototype.clearTeam = function() {
  return this.setTeam(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pi_customer_public.GetTeamResponse.prototype.hasTeam = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.TeamProto.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.TeamProto.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.TeamProto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.TeamProto.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    logoUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    dataRetentionPeriod: jspb.Message.getFieldWithDefault(msg, 5, 0),
    resolvedDataRetentionPeriod: jspb.Message.getFieldWithDefault(msg, 13, 0),
    tagRequiredToPostTime: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    seatPolicy: jspb.Message.getFieldWithDefault(msg, 19, 0),
    includeActivityDefault: jspb.Message.getFieldWithDefault(msg, 14, 0),
    subscriberInfo: (f = msg.getSubscriberInfo()) && proto.pi_customer_public.SubscriberInfo.toObject(includeInstance, f),
    teamRoundingPreference: jspb.Message.getFieldWithDefault(msg, 20, 0),
    roundingPreferenceSec: jspb.Message.getFieldWithDefault(msg, 23, 0),
    directTimelinePostPreference: jspb.Message.getFieldWithDefault(msg, 21, 0),
    preventTeamInvitesAndJoinRequests: jspb.Message.getBooleanFieldWithDefault(msg, 22, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.TeamProto}
 */
proto.pi_customer_public.TeamProto.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.TeamProto;
  return proto.pi_customer_public.TeamProto.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.TeamProto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.TeamProto}
 */
proto.pi_customer_public.TeamProto.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 5:
      var value = /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (reader.readEnum());
      msg.setDataRetentionPeriod(value);
      break;
    case 13:
      var value = /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (reader.readEnum());
      msg.setResolvedDataRetentionPeriod(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTagRequiredToPostTime(value);
      break;
    case 19:
      var value = /** @type {!proto.wisetime.type.seat.SeatAllocationPolicy} */ (reader.readEnum());
      msg.setSeatPolicy(value);
      break;
    case 14:
      var value = /** @type {!proto.pi_customer_public.IncludeActivityDefault} */ (reader.readEnum());
      msg.setIncludeActivityDefault(value);
      break;
    case 18:
      var value = new proto.pi_customer_public.SubscriberInfo;
      reader.readMessage(value,proto.pi_customer_public.SubscriberInfo.deserializeBinaryFromReader);
      msg.setSubscriberInfo(value);
      break;
    case 20:
      var value = /** @type {!proto.wisetime.type.RoundingPreference} */ (reader.readEnum());
      msg.setTeamRoundingPreference(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoundingPreferenceSec(value);
      break;
    case 21:
      var value = /** @type {!proto.wisetime.type.DirectTimelinePostPreference} */ (reader.readEnum());
      msg.setDirectTimelinePostPreference(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPreventTeamInvitesAndJoinRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.TeamProto.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.TeamProto.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.TeamProto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.TeamProto.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDataRetentionPeriod();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getResolvedDataRetentionPeriod();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getTagRequiredToPostTime();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getSeatPolicy();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getIncludeActivityDefault();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getSubscriberInfo();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.pi_customer_public.SubscriberInfo.serializeBinaryToWriter
    );
  }
  f = message.getTeamRoundingPreference();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getRoundingPreferenceSec();
  if (f !== 0) {
    writer.writeInt32(
      23,
      f
    );
  }
  f = message.getDirectTimelinePostPreference();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getPreventTeamInvitesAndJoinRequests();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.TeamProto.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pi_customer_public.TeamProto.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string logo_url = 3;
 * @return {string}
 */
proto.pi_customer_public.TeamProto.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional wisetime.type.DataRetentionPeriod data_retention_period = 5;
 * @return {!proto.wisetime.type.DataRetentionPeriod}
 */
proto.pi_customer_public.TeamProto.prototype.getDataRetentionPeriod = function() {
  return /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.wisetime.type.DataRetentionPeriod} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setDataRetentionPeriod = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional wisetime.type.DataRetentionPeriod resolved_data_retention_period = 13;
 * @return {!proto.wisetime.type.DataRetentionPeriod}
 */
proto.pi_customer_public.TeamProto.prototype.getResolvedDataRetentionPeriod = function() {
  return /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.wisetime.type.DataRetentionPeriod} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setResolvedDataRetentionPeriod = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional bool tag_required_to_post_time = 6;
 * @return {boolean}
 */
proto.pi_customer_public.TeamProto.prototype.getTagRequiredToPostTime = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setTagRequiredToPostTime = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional wisetime.type.seat.SeatAllocationPolicy seat_policy = 19;
 * @return {!proto.wisetime.type.seat.SeatAllocationPolicy}
 */
proto.pi_customer_public.TeamProto.prototype.getSeatPolicy = function() {
  return /** @type {!proto.wisetime.type.seat.SeatAllocationPolicy} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.wisetime.type.seat.SeatAllocationPolicy} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setSeatPolicy = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional IncludeActivityDefault include_activity_default = 14;
 * @return {!proto.pi_customer_public.IncludeActivityDefault}
 */
proto.pi_customer_public.TeamProto.prototype.getIncludeActivityDefault = function() {
  return /** @type {!proto.pi_customer_public.IncludeActivityDefault} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.pi_customer_public.IncludeActivityDefault} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setIncludeActivityDefault = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional SubscriberInfo subscriber_info = 18;
 * @return {?proto.pi_customer_public.SubscriberInfo}
 */
proto.pi_customer_public.TeamProto.prototype.getSubscriberInfo = function() {
  return /** @type{?proto.pi_customer_public.SubscriberInfo} */ (
    jspb.Message.getWrapperField(this, proto.pi_customer_public.SubscriberInfo, 18));
};


/**
 * @param {?proto.pi_customer_public.SubscriberInfo|undefined} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
*/
proto.pi_customer_public.TeamProto.prototype.setSubscriberInfo = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.clearSubscriberInfo = function() {
  return this.setSubscriberInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pi_customer_public.TeamProto.prototype.hasSubscriberInfo = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional wisetime.type.RoundingPreference team_rounding_preference = 20;
 * @return {!proto.wisetime.type.RoundingPreference}
 */
proto.pi_customer_public.TeamProto.prototype.getTeamRoundingPreference = function() {
  return /** @type {!proto.wisetime.type.RoundingPreference} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.wisetime.type.RoundingPreference} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setTeamRoundingPreference = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional int32 rounding_preference_sec = 23;
 * @return {number}
 */
proto.pi_customer_public.TeamProto.prototype.getRoundingPreferenceSec = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setRoundingPreferenceSec = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional wisetime.type.DirectTimelinePostPreference direct_timeline_post_preference = 21;
 * @return {!proto.wisetime.type.DirectTimelinePostPreference}
 */
proto.pi_customer_public.TeamProto.prototype.getDirectTimelinePostPreference = function() {
  return /** @type {!proto.wisetime.type.DirectTimelinePostPreference} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.wisetime.type.DirectTimelinePostPreference} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setDirectTimelinePostPreference = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * optional bool prevent_team_invites_and_join_requests = 22;
 * @return {boolean}
 */
proto.pi_customer_public.TeamProto.prototype.getPreventTeamInvitesAndJoinRequests = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pi_customer_public.TeamProto} returns this
 */
proto.pi_customer_public.TeamProto.prototype.setPreventTeamInvitesAndJoinRequests = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.SubscriberInfo.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.SubscriberInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.SubscriberInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.SubscriberInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SubscriberInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    subscriberId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    paymentMethod: jspb.Message.getFieldWithDefault(msg, 5, 0),
    currency: jspb.Message.getFieldWithDefault(msg, 6, 0),
    state: jspb.Message.getFieldWithDefault(msg, 7, 0),
    trashAtUtc: jspb.Message.getFieldWithDefault(msg, 8, 0),
    linkedTeamIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    channelPartnerCode: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.SubscriberInfo}
 */
proto.pi_customer_public.SubscriberInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.SubscriberInfo;
  return proto.pi_customer_public.SubscriberInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.SubscriberInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.SubscriberInfo}
 */
proto.pi_customer_public.SubscriberInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriberId(value);
      break;
    case 2:
      var value = /** @type {!proto.wt_srv_shared.TeamType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {!proto.pi_customer_public.SubscriberInfo.PaymentMethod} */ (reader.readEnum());
      msg.setPaymentMethod(value);
      break;
    case 6:
      var value = /** @type {!proto.wt_srv_shared.Currency} */ (reader.readEnum());
      msg.setCurrency(value);
      break;
    case 7:
      var value = /** @type {!proto.wt_srv_shared.SubscriberState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTrashAtUtc(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addLinkedTeamIds(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelPartnerCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.SubscriberInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.SubscriberInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.SubscriberInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SubscriberInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriberId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCurrency();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getTrashAtUtc();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getLinkedTeamIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getChannelPartnerCode();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pi_customer_public.SubscriberInfo.PaymentMethod = {
  PAYMENT_METHOD_UNSPECIFIED: 0,
  NONE: 1,
  AUTO_CREDIT_CARD: 2,
  BANK_TRANSFER: 3
};

/**
 * optional string subscriber_id = 1;
 * @return {string}
 */
proto.pi_customer_public.SubscriberInfo.prototype.getSubscriberId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.SubscriberInfo} returns this
 */
proto.pi_customer_public.SubscriberInfo.prototype.setSubscriberId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional wt_srv_shared.TeamType type = 2;
 * @return {!proto.wt_srv_shared.TeamType}
 */
proto.pi_customer_public.SubscriberInfo.prototype.getType = function() {
  return /** @type {!proto.wt_srv_shared.TeamType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.wt_srv_shared.TeamType} value
 * @return {!proto.pi_customer_public.SubscriberInfo} returns this
 */
proto.pi_customer_public.SubscriberInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional PaymentMethod payment_method = 5;
 * @return {!proto.pi_customer_public.SubscriberInfo.PaymentMethod}
 */
proto.pi_customer_public.SubscriberInfo.prototype.getPaymentMethod = function() {
  return /** @type {!proto.pi_customer_public.SubscriberInfo.PaymentMethod} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.pi_customer_public.SubscriberInfo.PaymentMethod} value
 * @return {!proto.pi_customer_public.SubscriberInfo} returns this
 */
proto.pi_customer_public.SubscriberInfo.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional wt_srv_shared.Currency currency = 6;
 * @return {!proto.wt_srv_shared.Currency}
 */
proto.pi_customer_public.SubscriberInfo.prototype.getCurrency = function() {
  return /** @type {!proto.wt_srv_shared.Currency} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.wt_srv_shared.Currency} value
 * @return {!proto.pi_customer_public.SubscriberInfo} returns this
 */
proto.pi_customer_public.SubscriberInfo.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional wt_srv_shared.SubscriberState state = 7;
 * @return {!proto.wt_srv_shared.SubscriberState}
 */
proto.pi_customer_public.SubscriberInfo.prototype.getState = function() {
  return /** @type {!proto.wt_srv_shared.SubscriberState} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.wt_srv_shared.SubscriberState} value
 * @return {!proto.pi_customer_public.SubscriberInfo} returns this
 */
proto.pi_customer_public.SubscriberInfo.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional uint64 trash_at_utc = 8;
 * @return {number}
 */
proto.pi_customer_public.SubscriberInfo.prototype.getTrashAtUtc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.pi_customer_public.SubscriberInfo} returns this
 */
proto.pi_customer_public.SubscriberInfo.prototype.setTrashAtUtc = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated string linked_team_ids = 9;
 * @return {!Array<string>}
 */
proto.pi_customer_public.SubscriberInfo.prototype.getLinkedTeamIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pi_customer_public.SubscriberInfo} returns this
 */
proto.pi_customer_public.SubscriberInfo.prototype.setLinkedTeamIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.SubscriberInfo} returns this
 */
proto.pi_customer_public.SubscriberInfo.prototype.addLinkedTeamIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.SubscriberInfo} returns this
 */
proto.pi_customer_public.SubscriberInfo.prototype.clearLinkedTeamIdsList = function() {
  return this.setLinkedTeamIdsList([]);
};


/**
 * optional string channel_partner_code = 10;
 * @return {string}
 */
proto.pi_customer_public.SubscriberInfo.prototype.getChannelPartnerCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.SubscriberInfo} returns this
 */
proto.pi_customer_public.SubscriberInfo.prototype.setChannelPartnerCode = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.GetMyTeamsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.GetMyTeamsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.GetMyTeamsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.GetMyTeamsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.GetMyTeamsRequest}
 */
proto.pi_customer_public.GetMyTeamsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.GetMyTeamsRequest;
  return proto.pi_customer_public.GetMyTeamsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.GetMyTeamsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.GetMyTeamsRequest}
 */
proto.pi_customer_public.GetMyTeamsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.GetMyTeamsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.GetMyTeamsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.GetMyTeamsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.GetMyTeamsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.GetMyTeamsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.GetMyTeamsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.GetMyTeamsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.GetMyTeamsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.GetMyTeamsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    myTeamsList: jspb.Message.toObjectList(msg.getMyTeamsList(),
    proto.pi_customer_public.MyTeam.toObject, includeInstance),
    departedTeamsList: jspb.Message.toObjectList(msg.getDepartedTeamsList(),
    proto.pi_customer_public.MyTeam.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.GetMyTeamsResponse}
 */
proto.pi_customer_public.GetMyTeamsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.GetMyTeamsResponse;
  return proto.pi_customer_public.GetMyTeamsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.GetMyTeamsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.GetMyTeamsResponse}
 */
proto.pi_customer_public.GetMyTeamsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pi_customer_public.MyTeam;
      reader.readMessage(value,proto.pi_customer_public.MyTeam.deserializeBinaryFromReader);
      msg.addMyTeams(value);
      break;
    case 2:
      var value = new proto.pi_customer_public.MyTeam;
      reader.readMessage(value,proto.pi_customer_public.MyTeam.deserializeBinaryFromReader);
      msg.addDepartedTeams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.GetMyTeamsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.GetMyTeamsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.GetMyTeamsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.GetMyTeamsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMyTeamsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pi_customer_public.MyTeam.serializeBinaryToWriter
    );
  }
  f = message.getDepartedTeamsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.pi_customer_public.MyTeam.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MyTeam my_teams = 1;
 * @return {!Array<!proto.pi_customer_public.MyTeam>}
 */
proto.pi_customer_public.GetMyTeamsResponse.prototype.getMyTeamsList = function() {
  return /** @type{!Array<!proto.pi_customer_public.MyTeam>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pi_customer_public.MyTeam, 1));
};


/**
 * @param {!Array<!proto.pi_customer_public.MyTeam>} value
 * @return {!proto.pi_customer_public.GetMyTeamsResponse} returns this
*/
proto.pi_customer_public.GetMyTeamsResponse.prototype.setMyTeamsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pi_customer_public.MyTeam=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.MyTeam}
 */
proto.pi_customer_public.GetMyTeamsResponse.prototype.addMyTeams = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pi_customer_public.MyTeam, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.GetMyTeamsResponse} returns this
 */
proto.pi_customer_public.GetMyTeamsResponse.prototype.clearMyTeamsList = function() {
  return this.setMyTeamsList([]);
};


/**
 * repeated MyTeam departed_teams = 2;
 * @return {!Array<!proto.pi_customer_public.MyTeam>}
 */
proto.pi_customer_public.GetMyTeamsResponse.prototype.getDepartedTeamsList = function() {
  return /** @type{!Array<!proto.pi_customer_public.MyTeam>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pi_customer_public.MyTeam, 2));
};


/**
 * @param {!Array<!proto.pi_customer_public.MyTeam>} value
 * @return {!proto.pi_customer_public.GetMyTeamsResponse} returns this
*/
proto.pi_customer_public.GetMyTeamsResponse.prototype.setDepartedTeamsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.pi_customer_public.MyTeam=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.MyTeam}
 */
proto.pi_customer_public.GetMyTeamsResponse.prototype.addDepartedTeams = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.pi_customer_public.MyTeam, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.GetMyTeamsResponse} returns this
 */
proto.pi_customer_public.GetMyTeamsResponse.prototype.clearDepartedTeamsList = function() {
  return this.setDepartedTeamsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.MyTeam.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.MyTeam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.MyTeam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.MyTeam.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    logoUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    maxDataRetentionPeriod: jspb.Message.getFieldWithDefault(msg, 4, 0),
    authority: jspb.Message.getFieldWithDefault(msg, 5, 0),
    isLastActiveMember: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    teamType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    isLastOwner: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.MyTeam}
 */
proto.pi_customer_public.MyTeam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.MyTeam;
  return proto.pi_customer_public.MyTeam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.MyTeam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.MyTeam}
 */
proto.pi_customer_public.MyTeam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogoUrl(value);
      break;
    case 4:
      var value = /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (reader.readEnum());
      msg.setMaxDataRetentionPeriod(value);
      break;
    case 5:
      var value = /** @type {!proto.wt_srv_shared.Authority} */ (reader.readEnum());
      msg.setAuthority(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLastActiveMember(value);
      break;
    case 7:
      var value = /** @type {!proto.wt_srv_shared.TeamType} */ (reader.readEnum());
      msg.setTeamType(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsLastOwner(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.MyTeam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.MyTeam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.MyTeam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.MyTeam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMaxDataRetentionPeriod();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getAuthority();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getIsLastActiveMember();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getTeamType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getIsLastOwner();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.MyTeam.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.MyTeam} returns this
 */
proto.pi_customer_public.MyTeam.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pi_customer_public.MyTeam.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.MyTeam} returns this
 */
proto.pi_customer_public.MyTeam.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string logo_url = 3;
 * @return {string}
 */
proto.pi_customer_public.MyTeam.prototype.getLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.MyTeam} returns this
 */
proto.pi_customer_public.MyTeam.prototype.setLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional wisetime.type.DataRetentionPeriod max_data_retention_period = 4;
 * @return {!proto.wisetime.type.DataRetentionPeriod}
 */
proto.pi_customer_public.MyTeam.prototype.getMaxDataRetentionPeriod = function() {
  return /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.wisetime.type.DataRetentionPeriod} value
 * @return {!proto.pi_customer_public.MyTeam} returns this
 */
proto.pi_customer_public.MyTeam.prototype.setMaxDataRetentionPeriod = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional wt_srv_shared.Authority authority = 5;
 * @return {!proto.wt_srv_shared.Authority}
 */
proto.pi_customer_public.MyTeam.prototype.getAuthority = function() {
  return /** @type {!proto.wt_srv_shared.Authority} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.wt_srv_shared.Authority} value
 * @return {!proto.pi_customer_public.MyTeam} returns this
 */
proto.pi_customer_public.MyTeam.prototype.setAuthority = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional bool is_last_active_member = 6;
 * @return {boolean}
 */
proto.pi_customer_public.MyTeam.prototype.getIsLastActiveMember = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pi_customer_public.MyTeam} returns this
 */
proto.pi_customer_public.MyTeam.prototype.setIsLastActiveMember = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional wt_srv_shared.TeamType team_type = 7;
 * @return {!proto.wt_srv_shared.TeamType}
 */
proto.pi_customer_public.MyTeam.prototype.getTeamType = function() {
  return /** @type {!proto.wt_srv_shared.TeamType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.wt_srv_shared.TeamType} value
 * @return {!proto.pi_customer_public.MyTeam} returns this
 */
proto.pi_customer_public.MyTeam.prototype.setTeamType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional bool is_last_owner = 8;
 * @return {boolean}
 */
proto.pi_customer_public.MyTeam.prototype.getIsLastOwner = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pi_customer_public.MyTeam} returns this
 */
proto.pi_customer_public.MyTeam.prototype.setIsLastOwner = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UpdateTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UpdateTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dataRetentionPeriod: jspb.Message.getFieldWithDefault(msg, 3, 0),
    tagRequiredToPostTime: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    includeActivityDetailsDefault: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UpdateTeamRequest}
 */
proto.pi_customer_public.UpdateTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UpdateTeamRequest;
  return proto.pi_customer_public.UpdateTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UpdateTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UpdateTeamRequest}
 */
proto.pi_customer_public.UpdateTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (reader.readEnum());
      msg.setDataRetentionPeriod(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTagRequiredToPostTime(value);
      break;
    case 7:
      var value = /** @type {!proto.pi_customer_public.IncludeActivityDefault} */ (reader.readEnum());
      msg.setIncludeActivityDetailsDefault(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UpdateTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UpdateTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDataRetentionPeriod();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTagRequiredToPostTime();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIncludeActivityDetailsDefault();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateTeamRequest} returns this
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateTeamRequest} returns this
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional wisetime.type.DataRetentionPeriod data_retention_period = 3;
 * @return {!proto.wisetime.type.DataRetentionPeriod}
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.getDataRetentionPeriod = function() {
  return /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.wisetime.type.DataRetentionPeriod} value
 * @return {!proto.pi_customer_public.UpdateTeamRequest} returns this
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.setDataRetentionPeriod = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool tag_required_to_post_time = 4;
 * @return {boolean}
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.getTagRequiredToPostTime = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pi_customer_public.UpdateTeamRequest} returns this
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.setTagRequiredToPostTime = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional IncludeActivityDefault include_activity_details_default = 7;
 * @return {!proto.pi_customer_public.IncludeActivityDefault}
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.getIncludeActivityDetailsDefault = function() {
  return /** @type {!proto.pi_customer_public.IncludeActivityDefault} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.pi_customer_public.IncludeActivityDefault} value
 * @return {!proto.pi_customer_public.UpdateTeamRequest} returns this
 */
proto.pi_customer_public.UpdateTeamRequest.prototype.setIncludeActivityDetailsDefault = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UpdateTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UpdateTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UpdateTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UpdateTeamResponse}
 */
proto.pi_customer_public.UpdateTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UpdateTeamResponse;
  return proto.pi_customer_public.UpdateTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UpdateTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UpdateTeamResponse}
 */
proto.pi_customer_public.UpdateTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.UpdateTeamStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UpdateTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UpdateTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UpdateTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional UpdateTeamStatus status = 1;
 * @return {!proto.pi_customer_public.UpdateTeamStatus}
 */
proto.pi_customer_public.UpdateTeamResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.UpdateTeamStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.UpdateTeamStatus} value
 * @return {!proto.pi_customer_public.UpdateTeamResponse} returns this
 */
proto.pi_customer_public.UpdateTeamResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UpdateTeamNameRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UpdateTeamNameRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UpdateTeamNameRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamNameRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UpdateTeamNameRequest}
 */
proto.pi_customer_public.UpdateTeamNameRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UpdateTeamNameRequest;
  return proto.pi_customer_public.UpdateTeamNameRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UpdateTeamNameRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UpdateTeamNameRequest}
 */
proto.pi_customer_public.UpdateTeamNameRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UpdateTeamNameRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UpdateTeamNameRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UpdateTeamNameRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamNameRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.UpdateTeamNameRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateTeamNameRequest} returns this
 */
proto.pi_customer_public.UpdateTeamNameRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pi_customer_public.UpdateTeamNameRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateTeamNameRequest} returns this
 */
proto.pi_customer_public.UpdateTeamNameRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UpdateTeamNameResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UpdateTeamNameResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UpdateTeamNameResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamNameResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UpdateTeamNameResponse}
 */
proto.pi_customer_public.UpdateTeamNameResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UpdateTeamNameResponse;
  return proto.pi_customer_public.UpdateTeamNameResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UpdateTeamNameResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UpdateTeamNameResponse}
 */
proto.pi_customer_public.UpdateTeamNameResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.UpdateTeamNameStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UpdateTeamNameResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UpdateTeamNameResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UpdateTeamNameResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamNameResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional UpdateTeamNameStatus status = 1;
 * @return {!proto.pi_customer_public.UpdateTeamNameStatus}
 */
proto.pi_customer_public.UpdateTeamNameResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.UpdateTeamNameStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.UpdateTeamNameStatus} value
 * @return {!proto.pi_customer_public.UpdateTeamNameResponse} returns this
 */
proto.pi_customer_public.UpdateTeamNameResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UploadTeamLogoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UploadTeamLogoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UploadTeamLogoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UploadTeamLogoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    imageData: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UploadTeamLogoRequest}
 */
proto.pi_customer_public.UploadTeamLogoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UploadTeamLogoRequest;
  return proto.pi_customer_public.UploadTeamLogoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UploadTeamLogoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UploadTeamLogoRequest}
 */
proto.pi_customer_public.UploadTeamLogoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UploadTeamLogoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UploadTeamLogoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UploadTeamLogoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UploadTeamLogoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getImageData();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.UploadTeamLogoRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UploadTeamLogoRequest} returns this
 */
proto.pi_customer_public.UploadTeamLogoRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string filename = 2;
 * @return {string}
 */
proto.pi_customer_public.UploadTeamLogoRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UploadTeamLogoRequest} returns this
 */
proto.pi_customer_public.UploadTeamLogoRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string image_data = 3;
 * @return {string}
 */
proto.pi_customer_public.UploadTeamLogoRequest.prototype.getImageData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UploadTeamLogoRequest} returns this
 */
proto.pi_customer_public.UploadTeamLogoRequest.prototype.setImageData = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UploadTeamLogoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UploadTeamLogoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UploadTeamLogoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UploadTeamLogoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamLogoUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UploadTeamLogoResponse}
 */
proto.pi_customer_public.UploadTeamLogoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UploadTeamLogoResponse;
  return proto.pi_customer_public.UploadTeamLogoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UploadTeamLogoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UploadTeamLogoResponse}
 */
proto.pi_customer_public.UploadTeamLogoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamLogoUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UploadTeamLogoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UploadTeamLogoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UploadTeamLogoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UploadTeamLogoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_logo_url = 1;
 * @return {string}
 */
proto.pi_customer_public.UploadTeamLogoResponse.prototype.getTeamLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UploadTeamLogoResponse} returns this
 */
proto.pi_customer_public.UploadTeamLogoResponse.prototype.setTeamLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.SetTeamRoundingPreferenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.SetTeamRoundingPreferenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    teamRoundingPreference: jspb.Message.getFieldWithDefault(msg, 2, 0),
    roundingPreferenceSec: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.SetTeamRoundingPreferenceRequest}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.SetTeamRoundingPreferenceRequest;
  return proto.pi_customer_public.SetTeamRoundingPreferenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.SetTeamRoundingPreferenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.SetTeamRoundingPreferenceRequest}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {!proto.wisetime.type.RoundingPreference} */ (reader.readEnum());
      msg.setTeamRoundingPreference(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoundingPreferenceSec(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.SetTeamRoundingPreferenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.SetTeamRoundingPreferenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTeamRoundingPreference();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRoundingPreferenceSec();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.SetTeamRoundingPreferenceRequest} returns this
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional wisetime.type.RoundingPreference team_rounding_preference = 2;
 * @return {!proto.wisetime.type.RoundingPreference}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.prototype.getTeamRoundingPreference = function() {
  return /** @type {!proto.wisetime.type.RoundingPreference} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.wisetime.type.RoundingPreference} value
 * @return {!proto.pi_customer_public.SetTeamRoundingPreferenceRequest} returns this
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.prototype.setTeamRoundingPreference = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 rounding_preference_sec = 3;
 * @return {number}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.prototype.getRoundingPreferenceSec = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pi_customer_public.SetTeamRoundingPreferenceRequest} returns this
 */
proto.pi_customer_public.SetTeamRoundingPreferenceRequest.prototype.setRoundingPreferenceSec = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.SetTeamRoundingPreferenceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.SetTeamRoundingPreferenceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SetTeamRoundingPreferenceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.SetTeamRoundingPreferenceResponse}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.SetTeamRoundingPreferenceResponse;
  return proto.pi_customer_public.SetTeamRoundingPreferenceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.SetTeamRoundingPreferenceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.SetTeamRoundingPreferenceResponse}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.SetTeamRoundingPreferenceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.SetTeamRoundingPreferenceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.SetTeamRoundingPreferenceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SetTeamRoundingPreferenceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    directTimelinePostPreference: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest}
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest;
  return proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest}
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {!proto.wisetime.type.DirectTimelinePostPreference} */ (reader.readEnum());
      msg.setDirectTimelinePostPreference(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDirectTimelinePostPreference();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest} returns this
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional wisetime.type.DirectTimelinePostPreference direct_timeline_post_preference = 2;
 * @return {!proto.wisetime.type.DirectTimelinePostPreference}
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.prototype.getDirectTimelinePostPreference = function() {
  return /** @type {!proto.wisetime.type.DirectTimelinePostPreference} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.wisetime.type.DirectTimelinePostPreference} value
 * @return {!proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest} returns this
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceRequest.prototype.setDirectTimelinePostPreference = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse}
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse;
  return proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse}
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SetDirectTimelinePostPreferenceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.DeleteTeamRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.DeleteTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.DeleteTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.DeleteTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeleteTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    deleteReasonsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    deleteTeamReasonMessage: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.DeleteTeamRequest}
 */
proto.pi_customer_public.DeleteTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.DeleteTeamRequest;
  return proto.pi_customer_public.DeleteTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.DeleteTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.DeleteTeamRequest}
 */
proto.pi_customer_public.DeleteTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.pi_customer_public.TeamDeleteReason>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addDeleteReasons(values[i]);
      }
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeleteTeamReasonMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.DeleteTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.DeleteTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.DeleteTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeleteTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeleteReasonsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getDeleteTeamReasonMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.DeleteTeamRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.DeleteTeamRequest} returns this
 */
proto.pi_customer_public.DeleteTeamRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated TeamDeleteReason delete_reasons = 2;
 * @return {!Array<!proto.pi_customer_public.TeamDeleteReason>}
 */
proto.pi_customer_public.DeleteTeamRequest.prototype.getDeleteReasonsList = function() {
  return /** @type {!Array<!proto.pi_customer_public.TeamDeleteReason>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.pi_customer_public.TeamDeleteReason>} value
 * @return {!proto.pi_customer_public.DeleteTeamRequest} returns this
 */
proto.pi_customer_public.DeleteTeamRequest.prototype.setDeleteReasonsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.pi_customer_public.TeamDeleteReason} value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.DeleteTeamRequest} returns this
 */
proto.pi_customer_public.DeleteTeamRequest.prototype.addDeleteReasons = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.DeleteTeamRequest} returns this
 */
proto.pi_customer_public.DeleteTeamRequest.prototype.clearDeleteReasonsList = function() {
  return this.setDeleteReasonsList([]);
};


/**
 * optional string delete_team_reason_message = 3;
 * @return {string}
 */
proto.pi_customer_public.DeleteTeamRequest.prototype.getDeleteTeamReasonMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.DeleteTeamRequest} returns this
 */
proto.pi_customer_public.DeleteTeamRequest.prototype.setDeleteTeamReasonMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.DeleteTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.DeleteTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.DeleteTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeleteTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.DeleteTeamResponse}
 */
proto.pi_customer_public.DeleteTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.DeleteTeamResponse;
  return proto.pi_customer_public.DeleteTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.DeleteTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.DeleteTeamResponse}
 */
proto.pi_customer_public.DeleteTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.DeleteTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.DeleteTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.DeleteTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeleteTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ListTeamInvitationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ListTeamInvitationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ListTeamInvitationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamInvitationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ListTeamInvitationsRequest}
 */
proto.pi_customer_public.ListTeamInvitationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ListTeamInvitationsRequest;
  return proto.pi_customer_public.ListTeamInvitationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ListTeamInvitationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ListTeamInvitationsRequest}
 */
proto.pi_customer_public.ListTeamInvitationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ListTeamInvitationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ListTeamInvitationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ListTeamInvitationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamInvitationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.ListTeamInvitationsRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ListTeamInvitationsRequest} returns this
 */
proto.pi_customer_public.ListTeamInvitationsRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.ListTeamInvitationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ListTeamInvitationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ListTeamInvitationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ListTeamInvitationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamInvitationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    invitationsList: jspb.Message.toObjectList(msg.getInvitationsList(),
    proto.pi_customer_public.TeamJoinInviteItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ListTeamInvitationsResponse}
 */
proto.pi_customer_public.ListTeamInvitationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ListTeamInvitationsResponse;
  return proto.pi_customer_public.ListTeamInvitationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ListTeamInvitationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ListTeamInvitationsResponse}
 */
proto.pi_customer_public.ListTeamInvitationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pi_customer_public.TeamJoinInviteItem;
      reader.readMessage(value,proto.pi_customer_public.TeamJoinInviteItem.deserializeBinaryFromReader);
      msg.addInvitations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ListTeamInvitationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ListTeamInvitationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ListTeamInvitationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamInvitationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pi_customer_public.TeamJoinInviteItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TeamJoinInviteItem invitations = 1;
 * @return {!Array<!proto.pi_customer_public.TeamJoinInviteItem>}
 */
proto.pi_customer_public.ListTeamInvitationsResponse.prototype.getInvitationsList = function() {
  return /** @type{!Array<!proto.pi_customer_public.TeamJoinInviteItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pi_customer_public.TeamJoinInviteItem, 1));
};


/**
 * @param {!Array<!proto.pi_customer_public.TeamJoinInviteItem>} value
 * @return {!proto.pi_customer_public.ListTeamInvitationsResponse} returns this
*/
proto.pi_customer_public.ListTeamInvitationsResponse.prototype.setInvitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pi_customer_public.TeamJoinInviteItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.TeamJoinInviteItem}
 */
proto.pi_customer_public.ListTeamInvitationsResponse.prototype.addInvitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pi_customer_public.TeamJoinInviteItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.ListTeamInvitationsResponse} returns this
 */
proto.pi_customer_public.ListTeamInvitationsResponse.prototype.clearInvitationsList = function() {
  return this.setInvitationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.TeamJoinInviteItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.TeamJoinInviteItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.TeamJoinInviteItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamJoinInviteId: jspb.Message.getFieldWithDefault(msg, 11, ""),
    accepted: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    emailRecipient: jspb.Message.getFieldWithDefault(msg, 1, ""),
    inviteeFirstName: jspb.Message.getFieldWithDefault(msg, 13, ""),
    inviteeLastName: jspb.Message.getFieldWithDefault(msg, 14, ""),
    piTeamId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    teamName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    authorityToAssign: jspb.Message.getFieldWithDefault(msg, 15, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.TeamJoinInviteItem}
 */
proto.pi_customer_public.TeamJoinInviteItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.TeamJoinInviteItem;
  return proto.pi_customer_public.TeamJoinInviteItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.TeamJoinInviteItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.TeamJoinInviteItem}
 */
proto.pi_customer_public.TeamJoinInviteItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamJoinInviteId(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccepted(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailRecipient(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteeFirstName(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteeLastName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPiTeamId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamName(value);
      break;
    case 15:
      var value = /** @type {!proto.wt_srv_shared.Authority} */ (reader.readEnum());
      msg.setAuthorityToAssign(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.TeamJoinInviteItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.TeamJoinInviteItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.TeamJoinInviteItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamJoinInviteId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAccepted();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getEmailRecipient();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInviteeFirstName();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getInviteeLastName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getPiTeamId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTeamName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAuthorityToAssign();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
};


/**
 * optional string team_join_invite_id = 11;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.getTeamJoinInviteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInviteItem} returns this
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.setTeamJoinInviteId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool accepted = 8;
 * @return {boolean}
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.getAccepted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pi_customer_public.TeamJoinInviteItem} returns this
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.setAccepted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string email_recipient = 1;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.getEmailRecipient = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInviteItem} returns this
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.setEmailRecipient = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string invitee_first_name = 13;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.getInviteeFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInviteItem} returns this
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.setInviteeFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string invitee_last_name = 14;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.getInviteeLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInviteItem} returns this
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.setInviteeLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string pi_team_id = 3;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.getPiTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInviteItem} returns this
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.setPiTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string team_name = 4;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.getTeamName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInviteItem} returns this
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.setTeamName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional wt_srv_shared.Authority authority_to_assign = 15;
 * @return {!proto.wt_srv_shared.Authority}
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.getAuthorityToAssign = function() {
  return /** @type {!proto.wt_srv_shared.Authority} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.wt_srv_shared.Authority} value
 * @return {!proto.pi_customer_public.TeamJoinInviteItem} returns this
 */
proto.pi_customer_public.TeamJoinInviteItem.prototype.setAuthorityToAssign = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.InviteUsersRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.InviteUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.InviteUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.InviteUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.InviteUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    inviteesList: jspb.Message.toObjectList(msg.getInviteesList(),
    proto.pi_customer_public.TeamJoinInvitee.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.InviteUsersRequest}
 */
proto.pi_customer_public.InviteUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.InviteUsersRequest;
  return proto.pi_customer_public.InviteUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.InviteUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.InviteUsersRequest}
 */
proto.pi_customer_public.InviteUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = new proto.pi_customer_public.TeamJoinInvitee;
      reader.readMessage(value,proto.pi_customer_public.TeamJoinInvitee.deserializeBinaryFromReader);
      msg.addInvitees(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.InviteUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.InviteUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.InviteUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.InviteUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInviteesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.pi_customer_public.TeamJoinInvitee.serializeBinaryToWriter
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.InviteUsersRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.InviteUsersRequest} returns this
 */
proto.pi_customer_public.InviteUsersRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated TeamJoinInvitee invitees = 2;
 * @return {!Array<!proto.pi_customer_public.TeamJoinInvitee>}
 */
proto.pi_customer_public.InviteUsersRequest.prototype.getInviteesList = function() {
  return /** @type{!Array<!proto.pi_customer_public.TeamJoinInvitee>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pi_customer_public.TeamJoinInvitee, 2));
};


/**
 * @param {!Array<!proto.pi_customer_public.TeamJoinInvitee>} value
 * @return {!proto.pi_customer_public.InviteUsersRequest} returns this
*/
proto.pi_customer_public.InviteUsersRequest.prototype.setInviteesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.pi_customer_public.TeamJoinInvitee=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.TeamJoinInvitee}
 */
proto.pi_customer_public.InviteUsersRequest.prototype.addInvitees = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.pi_customer_public.TeamJoinInvitee, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.InviteUsersRequest} returns this
 */
proto.pi_customer_public.InviteUsersRequest.prototype.clearInviteesList = function() {
  return this.setInviteesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.TeamJoinInvitee.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.TeamJoinInvitee} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.TeamJoinInvitee.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 11, ""),
    customMessage: jspb.Message.getFieldWithDefault(msg, 6, ""),
    authorityToAssign: jspb.Message.getFieldWithDefault(msg, 7, 0),
    industry: jspb.Message.getFieldWithDefault(msg, 8, ""),
    organisation: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.TeamJoinInvitee}
 */
proto.pi_customer_public.TeamJoinInvitee.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.TeamJoinInvitee;
  return proto.pi_customer_public.TeamJoinInvitee.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.TeamJoinInvitee} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.TeamJoinInvitee}
 */
proto.pi_customer_public.TeamJoinInvitee.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomMessage(value);
      break;
    case 7:
      var value = /** @type {!proto.wt_srv_shared.Authority} */ (reader.readEnum());
      msg.setAuthorityToAssign(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndustry(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganisation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.TeamJoinInvitee.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.TeamJoinInvitee} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.TeamJoinInvitee.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCustomMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAuthorityToAssign();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getIndustry();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOrganisation();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInvitee} returns this
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string first_name = 10;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInvitee} returns this
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string last_name = 11;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInvitee} returns this
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string custom_message = 6;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.getCustomMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInvitee} returns this
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.setCustomMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional wt_srv_shared.Authority authority_to_assign = 7;
 * @return {!proto.wt_srv_shared.Authority}
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.getAuthorityToAssign = function() {
  return /** @type {!proto.wt_srv_shared.Authority} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.wt_srv_shared.Authority} value
 * @return {!proto.pi_customer_public.TeamJoinInvitee} returns this
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.setAuthorityToAssign = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string industry = 8;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.getIndustry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInvitee} returns this
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.setIndustry = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string organisation = 9;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.getOrganisation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinInvitee} returns this
 */
proto.pi_customer_public.TeamJoinInvitee.prototype.setOrganisation = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.InviteUsersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.InviteUsersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.InviteUsersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.InviteUsersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.InviteUsersResponse}
 */
proto.pi_customer_public.InviteUsersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.InviteUsersResponse;
  return proto.pi_customer_public.InviteUsersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.InviteUsersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.InviteUsersResponse}
 */
proto.pi_customer_public.InviteUsersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.InviteUsersStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.InviteUsersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.InviteUsersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.InviteUsersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.InviteUsersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional InviteUsersStatus status = 1;
 * @return {!proto.pi_customer_public.InviteUsersStatus}
 */
proto.pi_customer_public.InviteUsersResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.InviteUsersStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.InviteUsersStatus} value
 * @return {!proto.pi_customer_public.InviteUsersResponse} returns this
 */
proto.pi_customer_public.InviteUsersResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.AcceptTeamJoinInviteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.AcceptTeamJoinInviteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.AcceptTeamJoinInviteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.AcceptTeamJoinInviteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamJoinInviteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.AcceptTeamJoinInviteRequest}
 */
proto.pi_customer_public.AcceptTeamJoinInviteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.AcceptTeamJoinInviteRequest;
  return proto.pi_customer_public.AcceptTeamJoinInviteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.AcceptTeamJoinInviteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.AcceptTeamJoinInviteRequest}
 */
proto.pi_customer_public.AcceptTeamJoinInviteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamJoinInviteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.AcceptTeamJoinInviteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.AcceptTeamJoinInviteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.AcceptTeamJoinInviteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.AcceptTeamJoinInviteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamJoinInviteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_join_invite_id = 1;
 * @return {string}
 */
proto.pi_customer_public.AcceptTeamJoinInviteRequest.prototype.getTeamJoinInviteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.AcceptTeamJoinInviteRequest} returns this
 */
proto.pi_customer_public.AcceptTeamJoinInviteRequest.prototype.setTeamJoinInviteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.AcceptTeamJoinInviteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.AcceptTeamJoinInviteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.AcceptTeamJoinInviteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.AcceptTeamJoinInviteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.AcceptTeamJoinInviteResponse}
 */
proto.pi_customer_public.AcceptTeamJoinInviteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.AcceptTeamJoinInviteResponse;
  return proto.pi_customer_public.AcceptTeamJoinInviteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.AcceptTeamJoinInviteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.AcceptTeamJoinInviteResponse}
 */
proto.pi_customer_public.AcceptTeamJoinInviteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.TeamJoinStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.AcceptTeamJoinInviteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.AcceptTeamJoinInviteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.AcceptTeamJoinInviteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.AcceptTeamJoinInviteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional TeamJoinStatus status = 1;
 * @return {!proto.pi_customer_public.TeamJoinStatus}
 */
proto.pi_customer_public.AcceptTeamJoinInviteResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.TeamJoinStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.TeamJoinStatus} value
 * @return {!proto.pi_customer_public.AcceptTeamJoinInviteResponse} returns this
 */
proto.pi_customer_public.AcceptTeamJoinInviteResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ResendInvitationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ResendInvitationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ResendInvitationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ResendInvitationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ResendInvitationRequest}
 */
proto.pi_customer_public.ResendInvitationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ResendInvitationRequest;
  return proto.pi_customer_public.ResendInvitationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ResendInvitationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ResendInvitationRequest}
 */
proto.pi_customer_public.ResendInvitationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ResendInvitationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ResendInvitationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ResendInvitationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ResendInvitationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.ResendInvitationRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ResendInvitationRequest} returns this
 */
proto.pi_customer_public.ResendInvitationRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.pi_customer_public.ResendInvitationRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ResendInvitationRequest} returns this
 */
proto.pi_customer_public.ResendInvitationRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ResendInvitationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ResendInvitationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ResendInvitationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ResendInvitationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ResendInvitationResponse}
 */
proto.pi_customer_public.ResendInvitationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ResendInvitationResponse;
  return proto.pi_customer_public.ResendInvitationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ResendInvitationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ResendInvitationResponse}
 */
proto.pi_customer_public.ResendInvitationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ResendInvitationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ResendInvitationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ResendInvitationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ResendInvitationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.CancelInvitationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.CancelInvitationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.CancelInvitationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelInvitationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamJoinInviteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.CancelInvitationRequest}
 */
proto.pi_customer_public.CancelInvitationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.CancelInvitationRequest;
  return proto.pi_customer_public.CancelInvitationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.CancelInvitationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.CancelInvitationRequest}
 */
proto.pi_customer_public.CancelInvitationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamJoinInviteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.CancelInvitationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.CancelInvitationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.CancelInvitationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelInvitationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamJoinInviteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_join_invite_id = 1;
 * @return {string}
 */
proto.pi_customer_public.CancelInvitationRequest.prototype.getTeamJoinInviteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.CancelInvitationRequest} returns this
 */
proto.pi_customer_public.CancelInvitationRequest.prototype.setTeamJoinInviteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.CancelInvitationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.CancelInvitationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.CancelInvitationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelInvitationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.CancelInvitationResponse}
 */
proto.pi_customer_public.CancelInvitationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.CancelInvitationResponse;
  return proto.pi_customer_public.CancelInvitationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.CancelInvitationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.CancelInvitationResponse}
 */
proto.pi_customer_public.CancelInvitationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.CancelInvitationStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.CancelInvitationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.CancelInvitationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.CancelInvitationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelInvitationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional CancelInvitationStatus status = 1;
 * @return {!proto.pi_customer_public.CancelInvitationStatus}
 */
proto.pi_customer_public.CancelInvitationResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.CancelInvitationStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.CancelInvitationStatus} value
 * @return {!proto.pi_customer_public.CancelInvitationResponse} returns this
 */
proto.pi_customer_public.CancelInvitationResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.SuggestTeamsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.SuggestTeamsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.SuggestTeamsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SuggestTeamsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.SuggestTeamsRequest}
 */
proto.pi_customer_public.SuggestTeamsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.SuggestTeamsRequest;
  return proto.pi_customer_public.SuggestTeamsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.SuggestTeamsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.SuggestTeamsRequest}
 */
proto.pi_customer_public.SuggestTeamsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.SuggestTeamsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.SuggestTeamsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.SuggestTeamsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SuggestTeamsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.SuggestTeamsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.SuggestTeamsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.SuggestTeamsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.SuggestTeamsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SuggestTeamsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamsList: jspb.Message.toObjectList(msg.getTeamsList(),
    proto.pi_customer_public.Team.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.SuggestTeamsResponse}
 */
proto.pi_customer_public.SuggestTeamsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.SuggestTeamsResponse;
  return proto.pi_customer_public.SuggestTeamsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.SuggestTeamsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.SuggestTeamsResponse}
 */
proto.pi_customer_public.SuggestTeamsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pi_customer_public.Team;
      reader.readMessage(value,proto.pi_customer_public.Team.deserializeBinaryFromReader);
      msg.addTeams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.SuggestTeamsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.SuggestTeamsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.SuggestTeamsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.SuggestTeamsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pi_customer_public.Team.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Team teams = 1;
 * @return {!Array<!proto.pi_customer_public.Team>}
 */
proto.pi_customer_public.SuggestTeamsResponse.prototype.getTeamsList = function() {
  return /** @type{!Array<!proto.pi_customer_public.Team>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pi_customer_public.Team, 1));
};


/**
 * @param {!Array<!proto.pi_customer_public.Team>} value
 * @return {!proto.pi_customer_public.SuggestTeamsResponse} returns this
*/
proto.pi_customer_public.SuggestTeamsResponse.prototype.setTeamsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pi_customer_public.Team=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.Team}
 */
proto.pi_customer_public.SuggestTeamsResponse.prototype.addTeams = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pi_customer_public.Team, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.SuggestTeamsResponse} returns this
 */
proto.pi_customer_public.SuggestTeamsResponse.prototype.clearTeamsList = function() {
  return this.setTeamsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.RequestToJoinTeamRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.RequestToJoinTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.RequestToJoinTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.RequestToJoinTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.RequestToJoinTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.RequestToJoinTeamRequest}
 */
proto.pi_customer_public.RequestToJoinTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.RequestToJoinTeamRequest;
  return proto.pi_customer_public.RequestToJoinTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.RequestToJoinTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.RequestToJoinTeamRequest}
 */
proto.pi_customer_public.RequestToJoinTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.RequestToJoinTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.RequestToJoinTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.RequestToJoinTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.RequestToJoinTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string team_id = 1;
 * @return {!Array<string>}
 */
proto.pi_customer_public.RequestToJoinTeamRequest.prototype.getTeamIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pi_customer_public.RequestToJoinTeamRequest} returns this
 */
proto.pi_customer_public.RequestToJoinTeamRequest.prototype.setTeamIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.RequestToJoinTeamRequest} returns this
 */
proto.pi_customer_public.RequestToJoinTeamRequest.prototype.addTeamId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.RequestToJoinTeamRequest} returns this
 */
proto.pi_customer_public.RequestToJoinTeamRequest.prototype.clearTeamIdList = function() {
  return this.setTeamIdList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.RequestToJoinTeamResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.RequestToJoinTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.RequestToJoinTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.RequestToJoinTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.RequestToJoinTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    resultList: jspb.Message.toObjectList(msg.getResultList(),
    proto.pi_customer_public.RequestToJoinTeamResult.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.RequestToJoinTeamResponse}
 */
proto.pi_customer_public.RequestToJoinTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.RequestToJoinTeamResponse;
  return proto.pi_customer_public.RequestToJoinTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.RequestToJoinTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.RequestToJoinTeamResponse}
 */
proto.pi_customer_public.RequestToJoinTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pi_customer_public.RequestToJoinTeamResult;
      reader.readMessage(value,proto.pi_customer_public.RequestToJoinTeamResult.deserializeBinaryFromReader);
      msg.addResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.RequestToJoinTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.RequestToJoinTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.RequestToJoinTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.RequestToJoinTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pi_customer_public.RequestToJoinTeamResult.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RequestToJoinTeamResult result = 1;
 * @return {!Array<!proto.pi_customer_public.RequestToJoinTeamResult>}
 */
proto.pi_customer_public.RequestToJoinTeamResponse.prototype.getResultList = function() {
  return /** @type{!Array<!proto.pi_customer_public.RequestToJoinTeamResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pi_customer_public.RequestToJoinTeamResult, 1));
};


/**
 * @param {!Array<!proto.pi_customer_public.RequestToJoinTeamResult>} value
 * @return {!proto.pi_customer_public.RequestToJoinTeamResponse} returns this
*/
proto.pi_customer_public.RequestToJoinTeamResponse.prototype.setResultList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pi_customer_public.RequestToJoinTeamResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.RequestToJoinTeamResult}
 */
proto.pi_customer_public.RequestToJoinTeamResponse.prototype.addResult = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pi_customer_public.RequestToJoinTeamResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.RequestToJoinTeamResponse} returns this
 */
proto.pi_customer_public.RequestToJoinTeamResponse.prototype.clearResultList = function() {
  return this.setResultList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.RequestToJoinTeamResult.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.RequestToJoinTeamResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.RequestToJoinTeamResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.RequestToJoinTeamResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.RequestToJoinTeamResult}
 */
proto.pi_customer_public.RequestToJoinTeamResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.RequestToJoinTeamResult;
  return proto.pi_customer_public.RequestToJoinTeamResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.RequestToJoinTeamResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.RequestToJoinTeamResult}
 */
proto.pi_customer_public.RequestToJoinTeamResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {!proto.pi_customer_public.RequestToJoinTeamStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.RequestToJoinTeamResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.RequestToJoinTeamResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.RequestToJoinTeamResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.RequestToJoinTeamResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.RequestToJoinTeamResult.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.RequestToJoinTeamResult} returns this
 */
proto.pi_customer_public.RequestToJoinTeamResult.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RequestToJoinTeamStatus status = 2;
 * @return {!proto.pi_customer_public.RequestToJoinTeamStatus}
 */
proto.pi_customer_public.RequestToJoinTeamResult.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.RequestToJoinTeamStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pi_customer_public.RequestToJoinTeamStatus} value
 * @return {!proto.pi_customer_public.RequestToJoinTeamResult} returns this
 */
proto.pi_customer_public.RequestToJoinTeamResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest}
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest;
  return proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest}
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pendingTeamJoinRequestsList: jspb.Message.toObjectList(msg.getPendingTeamJoinRequestsList(),
    proto.pi_customer_public.TeamJoinRequestRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse}
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse;
  return proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse}
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pi_customer_public.TeamJoinRequestRecord;
      reader.readMessage(value,proto.pi_customer_public.TeamJoinRequestRecord.deserializeBinaryFromReader);
      msg.addPendingTeamJoinRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPendingTeamJoinRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pi_customer_public.TeamJoinRequestRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TeamJoinRequestRecord pending_team_join_requests = 1;
 * @return {!Array<!proto.pi_customer_public.TeamJoinRequestRecord>}
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.prototype.getPendingTeamJoinRequestsList = function() {
  return /** @type{!Array<!proto.pi_customer_public.TeamJoinRequestRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pi_customer_public.TeamJoinRequestRecord, 1));
};


/**
 * @param {!Array<!proto.pi_customer_public.TeamJoinRequestRecord>} value
 * @return {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse} returns this
*/
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.prototype.setPendingTeamJoinRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pi_customer_public.TeamJoinRequestRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.TeamJoinRequestRecord}
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.prototype.addPendingTeamJoinRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pi_customer_public.TeamJoinRequestRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse} returns this
 */
proto.pi_customer_public.ListMyPendingTeamJoinRequestsResponse.prototype.clearPendingTeamJoinRequestsList = function() {
  return this.setPendingTeamJoinRequestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ResendRequestToJoinTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ResendRequestToJoinTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ResendRequestToJoinTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ResendRequestToJoinTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamJoinRequestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ResendRequestToJoinTeamRequest}
 */
proto.pi_customer_public.ResendRequestToJoinTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ResendRequestToJoinTeamRequest;
  return proto.pi_customer_public.ResendRequestToJoinTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ResendRequestToJoinTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ResendRequestToJoinTeamRequest}
 */
proto.pi_customer_public.ResendRequestToJoinTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamJoinRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ResendRequestToJoinTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ResendRequestToJoinTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ResendRequestToJoinTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ResendRequestToJoinTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamJoinRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_join_request_id = 1;
 * @return {string}
 */
proto.pi_customer_public.ResendRequestToJoinTeamRequest.prototype.getTeamJoinRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ResendRequestToJoinTeamRequest} returns this
 */
proto.pi_customer_public.ResendRequestToJoinTeamRequest.prototype.setTeamJoinRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ResendRequestToJoinTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ResendRequestToJoinTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ResendRequestToJoinTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ResendRequestToJoinTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ResendRequestToJoinTeamResponse}
 */
proto.pi_customer_public.ResendRequestToJoinTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ResendRequestToJoinTeamResponse;
  return proto.pi_customer_public.ResendRequestToJoinTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ResendRequestToJoinTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ResendRequestToJoinTeamResponse}
 */
proto.pi_customer_public.ResendRequestToJoinTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.ResendRequestToJoinStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ResendRequestToJoinTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ResendRequestToJoinTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ResendRequestToJoinTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ResendRequestToJoinTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ResendRequestToJoinStatus status = 1;
 * @return {!proto.pi_customer_public.ResendRequestToJoinStatus}
 */
proto.pi_customer_public.ResendRequestToJoinTeamResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.ResendRequestToJoinStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.ResendRequestToJoinStatus} value
 * @return {!proto.pi_customer_public.ResendRequestToJoinTeamResponse} returns this
 */
proto.pi_customer_public.ResendRequestToJoinTeamResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.TeamJoinRequestRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.TeamJoinRequestRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.TeamJoinRequestRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamJoinRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    team: (f = msg.getTeam()) && proto.pi_customer_public.Team.toObject(includeInstance, f),
    user: (f = msg.getUser()) && proto.pi_customer_public.TeamJoinUserInfo.toObject(includeInstance, f),
    timestamp: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.TeamJoinRequestRecord}
 */
proto.pi_customer_public.TeamJoinRequestRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.TeamJoinRequestRecord;
  return proto.pi_customer_public.TeamJoinRequestRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.TeamJoinRequestRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.TeamJoinRequestRecord}
 */
proto.pi_customer_public.TeamJoinRequestRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamJoinRequestId(value);
      break;
    case 2:
      var value = new proto.pi_customer_public.Team;
      reader.readMessage(value,proto.pi_customer_public.Team.deserializeBinaryFromReader);
      msg.setTeam(value);
      break;
    case 3:
      var value = new proto.pi_customer_public.TeamJoinUserInfo;
      reader.readMessage(value,proto.pi_customer_public.TeamJoinUserInfo.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.TeamJoinRequestRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.TeamJoinRequestRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.TeamJoinRequestRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamJoinRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTeam();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pi_customer_public.Team.serializeBinaryToWriter
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pi_customer_public.TeamJoinUserInfo.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional string team_join_request_id = 1;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.getTeamJoinRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinRequestRecord} returns this
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.setTeamJoinRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Team team = 2;
 * @return {?proto.pi_customer_public.Team}
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.getTeam = function() {
  return /** @type{?proto.pi_customer_public.Team} */ (
    jspb.Message.getWrapperField(this, proto.pi_customer_public.Team, 2));
};


/**
 * @param {?proto.pi_customer_public.Team|undefined} value
 * @return {!proto.pi_customer_public.TeamJoinRequestRecord} returns this
*/
proto.pi_customer_public.TeamJoinRequestRecord.prototype.setTeam = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pi_customer_public.TeamJoinRequestRecord} returns this
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.clearTeam = function() {
  return this.setTeam(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.hasTeam = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TeamJoinUserInfo user = 3;
 * @return {?proto.pi_customer_public.TeamJoinUserInfo}
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.getUser = function() {
  return /** @type{?proto.pi_customer_public.TeamJoinUserInfo} */ (
    jspb.Message.getWrapperField(this, proto.pi_customer_public.TeamJoinUserInfo, 3));
};


/**
 * @param {?proto.pi_customer_public.TeamJoinUserInfo|undefined} value
 * @return {!proto.pi_customer_public.TeamJoinRequestRecord} returns this
*/
proto.pi_customer_public.TeamJoinRequestRecord.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pi_customer_public.TeamJoinRequestRecord} returns this
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.hasUser = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 timestamp = 4;
 * @return {number}
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pi_customer_public.TeamJoinRequestRecord} returns this
 */
proto.pi_customer_public.TeamJoinRequestRecord.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.TeamJoinUserInfo.repeatedFields_ = [18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.TeamJoinUserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.TeamJoinUserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.TeamJoinUserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 5, ""),
    country: jspb.Message.getFieldWithDefault(msg, 6, ""),
    timezone: jspb.Message.getFieldWithDefault(msg, 11, ""),
    dataRetentionPeriod: jspb.Message.getFieldWithDefault(msg, 13, 0),
    resolvedDataRetentionPeriod: jspb.Message.getFieldWithDefault(msg, 15, 0),
    phone: jspb.Message.getFieldWithDefault(msg, 7, ""),
    state: jspb.Message.getFieldWithDefault(msg, 8, ""),
    address: jspb.Message.getFieldWithDefault(msg, 9, ""),
    zipCode: jspb.Message.getFieldWithDefault(msg, 10, ""),
    managementSystemTypesList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f,
    userPhotoUrl: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.TeamJoinUserInfo}
 */
proto.pi_customer_public.TeamJoinUserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.TeamJoinUserInfo;
  return proto.pi_customer_public.TeamJoinUserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.TeamJoinUserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.TeamJoinUserInfo}
 */
proto.pi_customer_public.TeamJoinUserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 13:
      var value = /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (reader.readEnum());
      msg.setDataRetentionPeriod(value);
      break;
    case 15:
      var value = /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (reader.readEnum());
      msg.setResolvedDataRetentionPeriod(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 18:
      var values = /** @type {!Array<!proto.wt_srv_shared.ManagementSystemType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addManagementSystemTypes(values[i]);
      }
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPhotoUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.TeamJoinUserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.TeamJoinUserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.TeamJoinUserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTimezone();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDataRetentionPeriod();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getResolvedDataRetentionPeriod();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getManagementSystemTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      18,
      f
    );
  }
  f = message.getUserPhotoUrl();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string first_name = 2;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string last_name = 3;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 5;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string country = 6;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string timezone = 11;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setTimezone = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional wisetime.type.DataRetentionPeriod data_retention_period = 13;
 * @return {!proto.wisetime.type.DataRetentionPeriod}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getDataRetentionPeriod = function() {
  return /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.wisetime.type.DataRetentionPeriod} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setDataRetentionPeriod = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional wisetime.type.DataRetentionPeriod resolved_data_retention_period = 15;
 * @return {!proto.wisetime.type.DataRetentionPeriod}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getResolvedDataRetentionPeriod = function() {
  return /** @type {!proto.wisetime.type.DataRetentionPeriod} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.wisetime.type.DataRetentionPeriod} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setResolvedDataRetentionPeriod = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string phone = 7;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string state = 8;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string address = 9;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string zip_code = 10;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated wt_srv_shared.ManagementSystemType management_system_types = 18;
 * @return {!Array<!proto.wt_srv_shared.ManagementSystemType>}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getManagementSystemTypesList = function() {
  return /** @type {!Array<!proto.wt_srv_shared.ManagementSystemType>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<!proto.wt_srv_shared.ManagementSystemType>} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setManagementSystemTypesList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {!proto.wt_srv_shared.ManagementSystemType} value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.addManagementSystemTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.clearManagementSystemTypesList = function() {
  return this.setManagementSystemTypesList([]);
};


/**
 * optional string user_photo_url = 19;
 * @return {string}
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.getUserPhotoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.TeamJoinUserInfo} returns this
 */
proto.pi_customer_public.TeamJoinUserInfo.prototype.setUserPhotoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.Team.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.Team.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.Team} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.Team.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.Team}
 */
proto.pi_customer_public.Team.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.Team;
  return proto.pi_customer_public.Team.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.Team} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.Team}
 */
proto.pi_customer_public.Team.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.Team.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.Team.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.Team} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.Team.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pi_customer_public.Team.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.Team} returns this
 */
proto.pi_customer_public.Team.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pi_customer_public.Team.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.Team} returns this
 */
proto.pi_customer_public.Team.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.CancelMyRequestToJoinTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamJoinRequestId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.CancelMyRequestToJoinTeamRequest}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.CancelMyRequestToJoinTeamRequest;
  return proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.CancelMyRequestToJoinTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.CancelMyRequestToJoinTeamRequest}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamJoinRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.CancelMyRequestToJoinTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamJoinRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_join_request_id = 1;
 * @return {string}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.prototype.getTeamJoinRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.CancelMyRequestToJoinTeamRequest} returns this
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamRequest.prototype.setTeamJoinRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.CancelMyRequestToJoinTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.CancelMyRequestToJoinTeamResponse}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.CancelMyRequestToJoinTeamResponse;
  return proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.CancelMyRequestToJoinTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.CancelMyRequestToJoinTeamResponse}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.CancelMyRequestToJoinTeamStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.CancelMyRequestToJoinTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional CancelMyRequestToJoinTeamStatus status = 1;
 * @return {!proto.pi_customer_public.CancelMyRequestToJoinTeamStatus}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.CancelMyRequestToJoinTeamStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.CancelMyRequestToJoinTeamStatus} value
 * @return {!proto.pi_customer_public.CancelMyRequestToJoinTeamResponse} returns this
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ListTeamJoinRequestsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ListTeamJoinRequestsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ListTeamJoinRequestsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamJoinRequestsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ListTeamJoinRequestsRequest}
 */
proto.pi_customer_public.ListTeamJoinRequestsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ListTeamJoinRequestsRequest;
  return proto.pi_customer_public.ListTeamJoinRequestsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ListTeamJoinRequestsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ListTeamJoinRequestsRequest}
 */
proto.pi_customer_public.ListTeamJoinRequestsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ListTeamJoinRequestsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ListTeamJoinRequestsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ListTeamJoinRequestsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamJoinRequestsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.ListTeamJoinRequestsRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ListTeamJoinRequestsRequest} returns this
 */
proto.pi_customer_public.ListTeamJoinRequestsRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ListTeamJoinRequestsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ListTeamJoinRequestsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamJoinRequestsList: jspb.Message.toObjectList(msg.getTeamJoinRequestsList(),
    proto.pi_customer_public.TeamJoinRequestRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ListTeamJoinRequestsResponse}
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ListTeamJoinRequestsResponse;
  return proto.pi_customer_public.ListTeamJoinRequestsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ListTeamJoinRequestsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ListTeamJoinRequestsResponse}
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pi_customer_public.TeamJoinRequestRecord;
      reader.readMessage(value,proto.pi_customer_public.TeamJoinRequestRecord.deserializeBinaryFromReader);
      msg.addTeamJoinRequests(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ListTeamJoinRequestsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ListTeamJoinRequestsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamJoinRequestsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pi_customer_public.TeamJoinRequestRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TeamJoinRequestRecord team_join_requests = 1;
 * @return {!Array<!proto.pi_customer_public.TeamJoinRequestRecord>}
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse.prototype.getTeamJoinRequestsList = function() {
  return /** @type{!Array<!proto.pi_customer_public.TeamJoinRequestRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pi_customer_public.TeamJoinRequestRecord, 1));
};


/**
 * @param {!Array<!proto.pi_customer_public.TeamJoinRequestRecord>} value
 * @return {!proto.pi_customer_public.ListTeamJoinRequestsResponse} returns this
*/
proto.pi_customer_public.ListTeamJoinRequestsResponse.prototype.setTeamJoinRequestsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pi_customer_public.TeamJoinRequestRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.TeamJoinRequestRecord}
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse.prototype.addTeamJoinRequests = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pi_customer_public.TeamJoinRequestRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.ListTeamJoinRequestsResponse} returns this
 */
proto.pi_customer_public.ListTeamJoinRequestsResponse.prototype.clearTeamJoinRequestsList = function() {
  return this.setTeamJoinRequestsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ApproveRequestToJoinTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ApproveRequestToJoinTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamJoinRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    authorityToAssign: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ApproveRequestToJoinTeamRequest}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ApproveRequestToJoinTeamRequest;
  return proto.pi_customer_public.ApproveRequestToJoinTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ApproveRequestToJoinTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ApproveRequestToJoinTeamRequest}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamJoinRequestId(value);
      break;
    case 2:
      var value = /** @type {!proto.wt_srv_shared.Authority} */ (reader.readEnum());
      msg.setAuthorityToAssign(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ApproveRequestToJoinTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ApproveRequestToJoinTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamJoinRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthorityToAssign();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string team_join_request_id = 1;
 * @return {string}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest.prototype.getTeamJoinRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ApproveRequestToJoinTeamRequest} returns this
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest.prototype.setTeamJoinRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional wt_srv_shared.Authority authority_to_assign = 2;
 * @return {!proto.wt_srv_shared.Authority}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest.prototype.getAuthorityToAssign = function() {
  return /** @type {!proto.wt_srv_shared.Authority} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.wt_srv_shared.Authority} value
 * @return {!proto.pi_customer_public.ApproveRequestToJoinTeamRequest} returns this
 */
proto.pi_customer_public.ApproveRequestToJoinTeamRequest.prototype.setAuthorityToAssign = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ApproveRequestToJoinTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ApproveRequestToJoinTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ApproveRequestToJoinTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ApproveRequestToJoinTeamResponse}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ApproveRequestToJoinTeamResponse;
  return proto.pi_customer_public.ApproveRequestToJoinTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ApproveRequestToJoinTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ApproveRequestToJoinTeamResponse}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.ApproveRequestToJoinTeamStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ApproveRequestToJoinTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ApproveRequestToJoinTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ApproveRequestToJoinTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ApproveRequestToJoinTeamStatus status = 1;
 * @return {!proto.pi_customer_public.ApproveRequestToJoinTeamStatus}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.ApproveRequestToJoinTeamStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.ApproveRequestToJoinTeamStatus} value
 * @return {!proto.pi_customer_public.ApproveRequestToJoinTeamResponse} returns this
 */
proto.pi_customer_public.ApproveRequestToJoinTeamResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.DeclineRequestToJoinTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.DeclineRequestToJoinTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamJoinRequestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    declineMessage: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.DeclineRequestToJoinTeamRequest}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.DeclineRequestToJoinTeamRequest;
  return proto.pi_customer_public.DeclineRequestToJoinTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.DeclineRequestToJoinTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.DeclineRequestToJoinTeamRequest}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamJoinRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeclineMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.DeclineRequestToJoinTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.DeclineRequestToJoinTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamJoinRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDeclineMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string team_join_request_id = 1;
 * @return {string}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest.prototype.getTeamJoinRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.DeclineRequestToJoinTeamRequest} returns this
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest.prototype.setTeamJoinRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string decline_message = 2;
 * @return {string}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest.prototype.getDeclineMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.DeclineRequestToJoinTeamRequest} returns this
 */
proto.pi_customer_public.DeclineRequestToJoinTeamRequest.prototype.setDeclineMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.DeclineRequestToJoinTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.DeclineRequestToJoinTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeclineRequestToJoinTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.DeclineRequestToJoinTeamResponse}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.DeclineRequestToJoinTeamResponse;
  return proto.pi_customer_public.DeclineRequestToJoinTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.DeclineRequestToJoinTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.DeclineRequestToJoinTeamResponse}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.DeclineRequestToJoinTeamStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.DeclineRequestToJoinTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.DeclineRequestToJoinTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeclineRequestToJoinTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional DeclineRequestToJoinTeamStatus status = 1;
 * @return {!proto.pi_customer_public.DeclineRequestToJoinTeamStatus}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.DeclineRequestToJoinTeamStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.DeclineRequestToJoinTeamStatus} value
 * @return {!proto.pi_customer_public.DeclineRequestToJoinTeamResponse} returns this
 */
proto.pi_customer_public.DeclineRequestToJoinTeamResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ListTeamMembershipsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ListTeamMembershipsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ListTeamMembershipsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamMembershipsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ListTeamMembershipsRequest}
 */
proto.pi_customer_public.ListTeamMembershipsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ListTeamMembershipsRequest;
  return proto.pi_customer_public.ListTeamMembershipsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ListTeamMembershipsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ListTeamMembershipsRequest}
 */
proto.pi_customer_public.ListTeamMembershipsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ListTeamMembershipsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ListTeamMembershipsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ListTeamMembershipsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamMembershipsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.ListTeamMembershipsRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ListTeamMembershipsRequest} returns this
 */
proto.pi_customer_public.ListTeamMembershipsRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.ListTeamMembershipsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ListTeamMembershipsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ListTeamMembershipsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ListTeamMembershipsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamMembershipsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    membershipsList: jspb.Message.toObjectList(msg.getMembershipsList(),
    proto.pi_customer_public.Membership.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ListTeamMembershipsResponse}
 */
proto.pi_customer_public.ListTeamMembershipsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ListTeamMembershipsResponse;
  return proto.pi_customer_public.ListTeamMembershipsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ListTeamMembershipsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ListTeamMembershipsResponse}
 */
proto.pi_customer_public.ListTeamMembershipsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pi_customer_public.Membership;
      reader.readMessage(value,proto.pi_customer_public.Membership.deserializeBinaryFromReader);
      msg.addMemberships(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ListTeamMembershipsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ListTeamMembershipsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ListTeamMembershipsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListTeamMembershipsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembershipsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pi_customer_public.Membership.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Membership memberships = 1;
 * @return {!Array<!proto.pi_customer_public.Membership>}
 */
proto.pi_customer_public.ListTeamMembershipsResponse.prototype.getMembershipsList = function() {
  return /** @type{!Array<!proto.pi_customer_public.Membership>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pi_customer_public.Membership, 1));
};


/**
 * @param {!Array<!proto.pi_customer_public.Membership>} value
 * @return {!proto.pi_customer_public.ListTeamMembershipsResponse} returns this
*/
proto.pi_customer_public.ListTeamMembershipsResponse.prototype.setMembershipsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pi_customer_public.Membership=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.Membership}
 */
proto.pi_customer_public.ListTeamMembershipsResponse.prototype.addMemberships = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pi_customer_public.Membership, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.ListTeamMembershipsResponse} returns this
 */
proto.pi_customer_public.ListTeamMembershipsResponse.prototype.clearMembershipsList = function() {
  return this.setMembershipsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.Membership.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.Membership.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.Membership} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.Membership.toObject = function(includeInstance, msg) {
  var f, obj = {
    membershipId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    teamId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    authority: jspb.Message.getFieldWithDefault(msg, 4, 0),
    membershipStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    businessRole: (f = msg.getBusinessRole()) && proto.pi_customer_public.BusinessRole.toObject(includeInstance, f),
    experienceWeightingPercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    externalUserId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    email: jspb.Message.getFieldWithDefault(msg, 10, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 11, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    userPhotoUrl: jspb.Message.getFieldWithDefault(msg, 13, ""),
    anonymizationRequested: jspb.Message.getBooleanFieldWithDefault(msg, 14, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.Membership}
 */
proto.pi_customer_public.Membership.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.Membership;
  return proto.pi_customer_public.Membership.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.Membership} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.Membership}
 */
proto.pi_customer_public.Membership.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {!proto.wt_srv_shared.Authority} */ (reader.readEnum());
      msg.setAuthority(value);
      break;
    case 5:
      var value = /** @type {!proto.pi_customer_public.MembershipStatus} */ (reader.readEnum());
      msg.setMembershipStatus(value);
      break;
    case 7:
      var value = new proto.pi_customer_public.BusinessRole;
      reader.readMessage(value,proto.pi_customer_public.BusinessRole.deserializeBinaryFromReader);
      msg.setBusinessRole(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setExperienceWeightingPercent(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalUserId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPhotoUrl(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAnonymizationRequested(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.Membership.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.Membership.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.Membership} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.Membership.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAuthority();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getMembershipStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getBusinessRole();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.pi_customer_public.BusinessRole.serializeBinaryToWriter
    );
  }
  f = message.getExperienceWeightingPercent();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = message.getExternalUserId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUserPhotoUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAnonymizationRequested();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
};


/**
 * optional string membership_id = 1;
 * @return {string}
 */
proto.pi_customer_public.Membership.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string team_id = 2;
 * @return {string}
 */
proto.pi_customer_public.Membership.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_id = 3;
 * @return {string}
 */
proto.pi_customer_public.Membership.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional wt_srv_shared.Authority authority = 4;
 * @return {!proto.wt_srv_shared.Authority}
 */
proto.pi_customer_public.Membership.prototype.getAuthority = function() {
  return /** @type {!proto.wt_srv_shared.Authority} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.wt_srv_shared.Authority} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setAuthority = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional MembershipStatus membership_status = 5;
 * @return {!proto.pi_customer_public.MembershipStatus}
 */
proto.pi_customer_public.Membership.prototype.getMembershipStatus = function() {
  return /** @type {!proto.pi_customer_public.MembershipStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.pi_customer_public.MembershipStatus} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setMembershipStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional BusinessRole business_role = 7;
 * @return {?proto.pi_customer_public.BusinessRole}
 */
proto.pi_customer_public.Membership.prototype.getBusinessRole = function() {
  return /** @type{?proto.pi_customer_public.BusinessRole} */ (
    jspb.Message.getWrapperField(this, proto.pi_customer_public.BusinessRole, 7));
};


/**
 * @param {?proto.pi_customer_public.BusinessRole|undefined} value
 * @return {!proto.pi_customer_public.Membership} returns this
*/
proto.pi_customer_public.Membership.prototype.setBusinessRole = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.clearBusinessRole = function() {
  return this.setBusinessRole(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pi_customer_public.Membership.prototype.hasBusinessRole = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional float experience_weighting_percent = 8;
 * @return {number}
 */
proto.pi_customer_public.Membership.prototype.getExperienceWeightingPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setExperienceWeightingPercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional string external_user_id = 9;
 * @return {string}
 */
proto.pi_customer_public.Membership.prototype.getExternalUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setExternalUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string email = 10;
 * @return {string}
 */
proto.pi_customer_public.Membership.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string first_name = 11;
 * @return {string}
 */
proto.pi_customer_public.Membership.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string last_name = 12;
 * @return {string}
 */
proto.pi_customer_public.Membership.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string user_photo_url = 13;
 * @return {string}
 */
proto.pi_customer_public.Membership.prototype.getUserPhotoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setUserPhotoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool anonymization_requested = 14;
 * @return {boolean}
 */
proto.pi_customer_public.Membership.prototype.getAnonymizationRequested = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pi_customer_public.Membership} returns this
 */
proto.pi_customer_public.Membership.prototype.setAnonymizationRequested = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.BusinessRole.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.BusinessRole.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.BusinessRole} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.BusinessRole.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessRoleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    teamId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.BusinessRole}
 */
proto.pi_customer_public.BusinessRole.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.BusinessRole;
  return proto.pi_customer_public.BusinessRole.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.BusinessRole} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.BusinessRole}
 */
proto.pi_customer_public.BusinessRole.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessRoleId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.BusinessRole.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.BusinessRole.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.BusinessRole} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.BusinessRole.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessRoleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string business_role_id = 1;
 * @return {string}
 */
proto.pi_customer_public.BusinessRole.prototype.getBusinessRoleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.BusinessRole} returns this
 */
proto.pi_customer_public.BusinessRole.prototype.setBusinessRoleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string team_id = 2;
 * @return {string}
 */
proto.pi_customer_public.BusinessRole.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.BusinessRole} returns this
 */
proto.pi_customer_public.BusinessRole.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.pi_customer_public.BusinessRole.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.BusinessRole} returns this
 */
proto.pi_customer_public.BusinessRole.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UpdateTeamMembershipRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UpdateTeamMembershipRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    membershipId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    membershipStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    businessRoleId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    experienceWeightingPercent: jspb.Message.getFieldWithDefault(msg, 7, 0),
    externalUserId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UpdateTeamMembershipRequest}
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UpdateTeamMembershipRequest;
  return proto.pi_customer_public.UpdateTeamMembershipRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UpdateTeamMembershipRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UpdateTeamMembershipRequest}
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMembershipId(value);
      break;
    case 5:
      var value = /** @type {!proto.pi_customer_public.MembershipStatus} */ (reader.readEnum());
      msg.setMembershipStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessRoleId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExperienceWeightingPercent(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UpdateTeamMembershipRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UpdateTeamMembershipRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMembershipId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMembershipStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getBusinessRoleId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getExperienceWeightingPercent();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getExternalUserId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string membership_id = 1;
 * @return {string}
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.getMembershipId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateTeamMembershipRequest} returns this
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.setMembershipId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MembershipStatus membership_status = 5;
 * @return {!proto.pi_customer_public.MembershipStatus}
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.getMembershipStatus = function() {
  return /** @type {!proto.pi_customer_public.MembershipStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.pi_customer_public.MembershipStatus} value
 * @return {!proto.pi_customer_public.UpdateTeamMembershipRequest} returns this
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.setMembershipStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string business_role_id = 6;
 * @return {string}
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.getBusinessRoleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateTeamMembershipRequest} returns this
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.setBusinessRoleId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 experience_weighting_percent = 7;
 * @return {number}
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.getExperienceWeightingPercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.pi_customer_public.UpdateTeamMembershipRequest} returns this
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.setExperienceWeightingPercent = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string external_user_id = 8;
 * @return {string}
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.getExternalUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateTeamMembershipRequest} returns this
 */
proto.pi_customer_public.UpdateTeamMembershipRequest.prototype.setExternalUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UpdateTeamMembershipResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UpdateTeamMembershipResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UpdateTeamMembershipResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamMembershipResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UpdateTeamMembershipResponse}
 */
proto.pi_customer_public.UpdateTeamMembershipResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UpdateTeamMembershipResponse;
  return proto.pi_customer_public.UpdateTeamMembershipResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UpdateTeamMembershipResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UpdateTeamMembershipResponse}
 */
proto.pi_customer_public.UpdateTeamMembershipResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UpdateTeamMembershipResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UpdateTeamMembershipResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UpdateTeamMembershipResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateTeamMembershipResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.CancelMembershipRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.CancelMembershipRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.CancelMembershipRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelMembershipRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.CancelMembershipRequest}
 */
proto.pi_customer_public.CancelMembershipRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.CancelMembershipRequest;
  return proto.pi_customer_public.CancelMembershipRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.CancelMembershipRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.CancelMembershipRequest}
 */
proto.pi_customer_public.CancelMembershipRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.CancelMembershipRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.CancelMembershipRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.CancelMembershipRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelMembershipRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.CancelMembershipRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.CancelMembershipRequest} returns this
 */
proto.pi_customer_public.CancelMembershipRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.pi_customer_public.CancelMembershipRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.CancelMembershipRequest} returns this
 */
proto.pi_customer_public.CancelMembershipRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.CancelMembershipResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.CancelMembershipResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.CancelMembershipResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelMembershipResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.CancelMembershipResponse}
 */
proto.pi_customer_public.CancelMembershipResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.CancelMembershipResponse;
  return proto.pi_customer_public.CancelMembershipResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.CancelMembershipResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.CancelMembershipResponse}
 */
proto.pi_customer_public.CancelMembershipResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.CancelMembershipStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.CancelMembershipResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.CancelMembershipResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.CancelMembershipResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CancelMembershipResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional CancelMembershipStatus status = 1;
 * @return {!proto.pi_customer_public.CancelMembershipStatus}
 */
proto.pi_customer_public.CancelMembershipResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.CancelMembershipStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.CancelMembershipStatus} value
 * @return {!proto.pi_customer_public.CancelMembershipResponse} returns this
 */
proto.pi_customer_public.CancelMembershipResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ActivateMembershipRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ActivateMembershipRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ActivateMembershipRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ActivateMembershipRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ActivateMembershipRequest}
 */
proto.pi_customer_public.ActivateMembershipRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ActivateMembershipRequest;
  return proto.pi_customer_public.ActivateMembershipRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ActivateMembershipRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ActivateMembershipRequest}
 */
proto.pi_customer_public.ActivateMembershipRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ActivateMembershipRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ActivateMembershipRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ActivateMembershipRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ActivateMembershipRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.ActivateMembershipRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ActivateMembershipRequest} returns this
 */
proto.pi_customer_public.ActivateMembershipRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.pi_customer_public.ActivateMembershipRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ActivateMembershipRequest} returns this
 */
proto.pi_customer_public.ActivateMembershipRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ActivateMembershipResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ActivateMembershipResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ActivateMembershipResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ActivateMembershipResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ActivateMembershipResponse}
 */
proto.pi_customer_public.ActivateMembershipResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ActivateMembershipResponse;
  return proto.pi_customer_public.ActivateMembershipResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ActivateMembershipResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ActivateMembershipResponse}
 */
proto.pi_customer_public.ActivateMembershipResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.ActivateMembershipStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ActivateMembershipResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ActivateMembershipResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ActivateMembershipResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ActivateMembershipResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ActivateMembershipStatus status = 1;
 * @return {!proto.pi_customer_public.ActivateMembershipStatus}
 */
proto.pi_customer_public.ActivateMembershipResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.ActivateMembershipStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.ActivateMembershipStatus} value
 * @return {!proto.pi_customer_public.ActivateMembershipResponse} returns this
 */
proto.pi_customer_public.ActivateMembershipResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ForgetTeamMemberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ForgetTeamMemberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ForgetTeamMemberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ForgetTeamMemberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ForgetTeamMemberRequest}
 */
proto.pi_customer_public.ForgetTeamMemberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ForgetTeamMemberRequest;
  return proto.pi_customer_public.ForgetTeamMemberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ForgetTeamMemberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ForgetTeamMemberRequest}
 */
proto.pi_customer_public.ForgetTeamMemberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ForgetTeamMemberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ForgetTeamMemberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ForgetTeamMemberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ForgetTeamMemberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.ForgetTeamMemberRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ForgetTeamMemberRequest} returns this
 */
proto.pi_customer_public.ForgetTeamMemberRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.pi_customer_public.ForgetTeamMemberRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ForgetTeamMemberRequest} returns this
 */
proto.pi_customer_public.ForgetTeamMemberRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ForgetTeamMemberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ForgetTeamMemberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ForgetTeamMemberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ForgetTeamMemberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ForgetTeamMemberResponse}
 */
proto.pi_customer_public.ForgetTeamMemberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ForgetTeamMemberResponse;
  return proto.pi_customer_public.ForgetTeamMemberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ForgetTeamMemberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ForgetTeamMemberResponse}
 */
proto.pi_customer_public.ForgetTeamMemberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.ForgetTeamMemberStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ForgetTeamMemberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ForgetTeamMemberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ForgetTeamMemberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ForgetTeamMemberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ForgetTeamMemberStatus status = 1;
 * @return {!proto.pi_customer_public.ForgetTeamMemberStatus}
 */
proto.pi_customer_public.ForgetTeamMemberResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.ForgetTeamMemberStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.ForgetTeamMemberStatus} value
 * @return {!proto.pi_customer_public.ForgetTeamMemberResponse} returns this
 */
proto.pi_customer_public.ForgetTeamMemberResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.InvokeRightToBeForgottenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.InvokeRightToBeForgottenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.InvokeRightToBeForgottenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.InvokeRightToBeForgottenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.InvokeRightToBeForgottenRequest}
 */
proto.pi_customer_public.InvokeRightToBeForgottenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.InvokeRightToBeForgottenRequest;
  return proto.pi_customer_public.InvokeRightToBeForgottenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.InvokeRightToBeForgottenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.InvokeRightToBeForgottenRequest}
 */
proto.pi_customer_public.InvokeRightToBeForgottenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.InvokeRightToBeForgottenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.InvokeRightToBeForgottenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.InvokeRightToBeForgottenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.InvokeRightToBeForgottenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.InvokeRightToBeForgottenRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.InvokeRightToBeForgottenRequest} returns this
 */
proto.pi_customer_public.InvokeRightToBeForgottenRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.InvokeRightToBeForgottenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.InvokeRightToBeForgottenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.InvokeRightToBeForgottenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.InvokeRightToBeForgottenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.InvokeRightToBeForgottenResponse}
 */
proto.pi_customer_public.InvokeRightToBeForgottenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.InvokeRightToBeForgottenResponse;
  return proto.pi_customer_public.InvokeRightToBeForgottenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.InvokeRightToBeForgottenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.InvokeRightToBeForgottenResponse}
 */
proto.pi_customer_public.InvokeRightToBeForgottenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.ForgottenStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.InvokeRightToBeForgottenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.InvokeRightToBeForgottenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.InvokeRightToBeForgottenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.InvokeRightToBeForgottenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ForgottenStatus status = 1;
 * @return {!proto.pi_customer_public.ForgottenStatus}
 */
proto.pi_customer_public.InvokeRightToBeForgottenResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.ForgottenStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.ForgottenStatus} value
 * @return {!proto.pi_customer_public.InvokeRightToBeForgottenResponse} returns this
 */
proto.pi_customer_public.InvokeRightToBeForgottenResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UpdateAuthorityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UpdateAuthorityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UpdateAuthorityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateAuthorityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    authority: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UpdateAuthorityRequest}
 */
proto.pi_customer_public.UpdateAuthorityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UpdateAuthorityRequest;
  return proto.pi_customer_public.UpdateAuthorityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UpdateAuthorityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UpdateAuthorityRequest}
 */
proto.pi_customer_public.UpdateAuthorityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {!proto.wt_srv_shared.Authority} */ (reader.readEnum());
      msg.setAuthority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UpdateAuthorityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UpdateAuthorityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UpdateAuthorityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateAuthorityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAuthority();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.UpdateAuthorityRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateAuthorityRequest} returns this
 */
proto.pi_customer_public.UpdateAuthorityRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.pi_customer_public.UpdateAuthorityRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateAuthorityRequest} returns this
 */
proto.pi_customer_public.UpdateAuthorityRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional wt_srv_shared.Authority authority = 3;
 * @return {!proto.wt_srv_shared.Authority}
 */
proto.pi_customer_public.UpdateAuthorityRequest.prototype.getAuthority = function() {
  return /** @type {!proto.wt_srv_shared.Authority} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.wt_srv_shared.Authority} value
 * @return {!proto.pi_customer_public.UpdateAuthorityRequest} returns this
 */
proto.pi_customer_public.UpdateAuthorityRequest.prototype.setAuthority = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UpdateAuthorityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UpdateAuthorityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UpdateAuthorityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateAuthorityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UpdateAuthorityResponse}
 */
proto.pi_customer_public.UpdateAuthorityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UpdateAuthorityResponse;
  return proto.pi_customer_public.UpdateAuthorityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UpdateAuthorityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UpdateAuthorityResponse}
 */
proto.pi_customer_public.UpdateAuthorityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.pi_customer_public.UpdateAuthorityStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UpdateAuthorityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UpdateAuthorityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UpdateAuthorityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateAuthorityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional UpdateAuthorityStatus status = 1;
 * @return {!proto.pi_customer_public.UpdateAuthorityStatus}
 */
proto.pi_customer_public.UpdateAuthorityResponse.prototype.getStatus = function() {
  return /** @type {!proto.pi_customer_public.UpdateAuthorityStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.pi_customer_public.UpdateAuthorityStatus} value
 * @return {!proto.pi_customer_public.UpdateAuthorityResponse} returns this
 */
proto.pi_customer_public.UpdateAuthorityResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ListBusinessRolesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ListBusinessRolesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ListBusinessRolesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListBusinessRolesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ListBusinessRolesRequest}
 */
proto.pi_customer_public.ListBusinessRolesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ListBusinessRolesRequest;
  return proto.pi_customer_public.ListBusinessRolesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ListBusinessRolesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ListBusinessRolesRequest}
 */
proto.pi_customer_public.ListBusinessRolesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ListBusinessRolesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ListBusinessRolesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ListBusinessRolesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListBusinessRolesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.ListBusinessRolesRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.ListBusinessRolesRequest} returns this
 */
proto.pi_customer_public.ListBusinessRolesRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pi_customer_public.ListBusinessRolesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.ListBusinessRolesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.ListBusinessRolesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.ListBusinessRolesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListBusinessRolesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessRolesList: jspb.Message.toObjectList(msg.getBusinessRolesList(),
    proto.pi_customer_public.BusinessRole.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.ListBusinessRolesResponse}
 */
proto.pi_customer_public.ListBusinessRolesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.ListBusinessRolesResponse;
  return proto.pi_customer_public.ListBusinessRolesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.ListBusinessRolesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.ListBusinessRolesResponse}
 */
proto.pi_customer_public.ListBusinessRolesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pi_customer_public.BusinessRole;
      reader.readMessage(value,proto.pi_customer_public.BusinessRole.deserializeBinaryFromReader);
      msg.addBusinessRoles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.ListBusinessRolesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.ListBusinessRolesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.ListBusinessRolesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.ListBusinessRolesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessRolesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pi_customer_public.BusinessRole.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BusinessRole business_roles = 1;
 * @return {!Array<!proto.pi_customer_public.BusinessRole>}
 */
proto.pi_customer_public.ListBusinessRolesResponse.prototype.getBusinessRolesList = function() {
  return /** @type{!Array<!proto.pi_customer_public.BusinessRole>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pi_customer_public.BusinessRole, 1));
};


/**
 * @param {!Array<!proto.pi_customer_public.BusinessRole>} value
 * @return {!proto.pi_customer_public.ListBusinessRolesResponse} returns this
*/
proto.pi_customer_public.ListBusinessRolesResponse.prototype.setBusinessRolesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pi_customer_public.BusinessRole=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pi_customer_public.BusinessRole}
 */
proto.pi_customer_public.ListBusinessRolesResponse.prototype.addBusinessRoles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pi_customer_public.BusinessRole, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pi_customer_public.ListBusinessRolesResponse} returns this
 */
proto.pi_customer_public.ListBusinessRolesResponse.prototype.clearBusinessRolesList = function() {
  return this.setBusinessRolesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.CreateBusinessRoleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.CreateBusinessRoleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.CreateBusinessRoleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CreateBusinessRoleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.CreateBusinessRoleRequest}
 */
proto.pi_customer_public.CreateBusinessRoleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.CreateBusinessRoleRequest;
  return proto.pi_customer_public.CreateBusinessRoleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.CreateBusinessRoleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.CreateBusinessRoleRequest}
 */
proto.pi_customer_public.CreateBusinessRoleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.CreateBusinessRoleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.CreateBusinessRoleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.CreateBusinessRoleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CreateBusinessRoleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string team_id = 1;
 * @return {string}
 */
proto.pi_customer_public.CreateBusinessRoleRequest.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.CreateBusinessRoleRequest} returns this
 */
proto.pi_customer_public.CreateBusinessRoleRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pi_customer_public.CreateBusinessRoleRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.CreateBusinessRoleRequest} returns this
 */
proto.pi_customer_public.CreateBusinessRoleRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.CreateBusinessRoleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.CreateBusinessRoleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.CreateBusinessRoleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CreateBusinessRoleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.CreateBusinessRoleResponse}
 */
proto.pi_customer_public.CreateBusinessRoleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.CreateBusinessRoleResponse;
  return proto.pi_customer_public.CreateBusinessRoleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.CreateBusinessRoleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.CreateBusinessRoleResponse}
 */
proto.pi_customer_public.CreateBusinessRoleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.CreateBusinessRoleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.CreateBusinessRoleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.CreateBusinessRoleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.CreateBusinessRoleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UpdateBusinessRoleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UpdateBusinessRoleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UpdateBusinessRoleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateBusinessRoleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessRoleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UpdateBusinessRoleRequest}
 */
proto.pi_customer_public.UpdateBusinessRoleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UpdateBusinessRoleRequest;
  return proto.pi_customer_public.UpdateBusinessRoleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UpdateBusinessRoleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UpdateBusinessRoleRequest}
 */
proto.pi_customer_public.UpdateBusinessRoleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessRoleId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UpdateBusinessRoleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UpdateBusinessRoleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UpdateBusinessRoleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateBusinessRoleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessRoleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string business_role_id = 1;
 * @return {string}
 */
proto.pi_customer_public.UpdateBusinessRoleRequest.prototype.getBusinessRoleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateBusinessRoleRequest} returns this
 */
proto.pi_customer_public.UpdateBusinessRoleRequest.prototype.setBusinessRoleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pi_customer_public.UpdateBusinessRoleRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.UpdateBusinessRoleRequest} returns this
 */
proto.pi_customer_public.UpdateBusinessRoleRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.UpdateBusinessRoleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.UpdateBusinessRoleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.UpdateBusinessRoleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateBusinessRoleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.UpdateBusinessRoleResponse}
 */
proto.pi_customer_public.UpdateBusinessRoleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.UpdateBusinessRoleResponse;
  return proto.pi_customer_public.UpdateBusinessRoleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.UpdateBusinessRoleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.UpdateBusinessRoleResponse}
 */
proto.pi_customer_public.UpdateBusinessRoleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.UpdateBusinessRoleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.UpdateBusinessRoleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.UpdateBusinessRoleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.UpdateBusinessRoleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.DeleteBusinessRoleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.DeleteBusinessRoleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.DeleteBusinessRoleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeleteBusinessRoleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessRoleId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.DeleteBusinessRoleRequest}
 */
proto.pi_customer_public.DeleteBusinessRoleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.DeleteBusinessRoleRequest;
  return proto.pi_customer_public.DeleteBusinessRoleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.DeleteBusinessRoleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.DeleteBusinessRoleRequest}
 */
proto.pi_customer_public.DeleteBusinessRoleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessRoleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.DeleteBusinessRoleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.DeleteBusinessRoleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.DeleteBusinessRoleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeleteBusinessRoleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessRoleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string business_role_id = 1;
 * @return {string}
 */
proto.pi_customer_public.DeleteBusinessRoleRequest.prototype.getBusinessRoleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pi_customer_public.DeleteBusinessRoleRequest} returns this
 */
proto.pi_customer_public.DeleteBusinessRoleRequest.prototype.setBusinessRoleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pi_customer_public.DeleteBusinessRoleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pi_customer_public.DeleteBusinessRoleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pi_customer_public.DeleteBusinessRoleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeleteBusinessRoleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pi_customer_public.DeleteBusinessRoleResponse}
 */
proto.pi_customer_public.DeleteBusinessRoleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pi_customer_public.DeleteBusinessRoleResponse;
  return proto.pi_customer_public.DeleteBusinessRoleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pi_customer_public.DeleteBusinessRoleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pi_customer_public.DeleteBusinessRoleResponse}
 */
proto.pi_customer_public.DeleteBusinessRoleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pi_customer_public.DeleteBusinessRoleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pi_customer_public.DeleteBusinessRoleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pi_customer_public.DeleteBusinessRoleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pi_customer_public.DeleteBusinessRoleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.pi_customer_public.CreateTeamStatus = {
  CREATE_TEAM_STATUS_UNSPECIFIED: 0,
  CREATE_TEAM_SUCCESS: 1,
  CANT_CREATE_TEAM_INVALID_REQUEST: 2,
  CANT_CREATE_TEAM_ALREADY_EXISTS_IN_ORGANIZATION: 3,
  CANT_CREATE_TEAM_INTERNAL_ERROR: 4,
  CANT_CREATE_TEAM_STARTER_TEAM_LIMIT_REACHED: 5,
  CANT_CREATE_TEAM_TEAM_LIMIT_REACHED: 6
};

/**
 * @enum {number}
 */
proto.pi_customer_public.IncludeActivityDefault = {
  INCLUDE_DETAIL_UNKNOWN: 0,
  INCLUDE_DETAIL_ENABLED: 1,
  INCLUDE_DETAIL_DISABLED: 2
};

/**
 * @enum {number}
 */
proto.pi_customer_public.UpdateTeamStatus = {
  UPDATE_TEAM_UNSPECIFIED: 0,
  UPDATE_TEAM_SUCCESS: 1,
  CANT_UPDATE_TEAM_NOT_FOUND: 2,
  CANT_UPDATE_TEAM_ALREADY_EXISTS: 3,
  CANT_UPDATE_TEAM_INVALID_RETENTION: 4
};

/**
 * @enum {number}
 */
proto.pi_customer_public.UpdateTeamNameStatus = {
  UPDATE_TEAM_NAME_UNSPECIFIED: 0,
  UPDATE_TEAM_NAME_SUCCESS: 1,
  CANT_UPDATE_TEAM_NAME_NOT_FOUND: 2,
  CANT_UPDATE_TEAM_NAME_ALREADY_EXISTS: 3
};

/**
 * @enum {number}
 */
proto.pi_customer_public.TeamDeleteReason = {
  TEAM_DELETE_REASON_UNSPECIFIED: 0,
  TEAM_DELETE_REASON_LACKED_FEATURES: 1,
  TEAM_DELETE_REASON_TOO_COSTLY: 2,
  TEAM_DELETE_REASON_NO_SUPPORT: 3,
  TEAM_DELETE_REASON_SUBSTITUTE_PRODUCT: 4,
  TEAM_DELETE_REASON_OTHER_REASON: 5,
  TEAM_DELETE_REASON_INTEGRATION_NOT_SUPPORTED: 6
};

/**
 * @enum {number}
 */
proto.pi_customer_public.InviteUsersStatus = {
  INVITE_USERS_STATUS_UNSPECIFIED: 0,
  INVITE_USERS_SUCCESS: 1,
  CANT_INVITE_USERS_MAX_MEMBERS_EXCEEDED: 2,
  CANT_INVITE_USERS_PERMISSION_DENIED: 3,
  CANT_INVITE_USERS_TEAM_NOT_FOUND: 4
};

/**
 * @enum {number}
 */
proto.pi_customer_public.TeamJoinStatus = {
  INVALID_INVITE_ID: 0,
  ALREADY_JOINED: 1,
  JOIN_SUCCESS: 2,
  CANT_JOIN_TEAM_USER_NOT_FOUND: 3,
  CANT_JOIN_TEAM_INVITE_NOT_FOUND: 4,
  CANT_JOIN_TEAM_INVITE_DETAILS_NOT_FOUND: 5,
  CANT_JOIN_TEAM_NOT_AVAILABLE: 6
};

/**
 * @enum {number}
 */
proto.pi_customer_public.CancelInvitationStatus = {
  CANCEL_STATUS_UNSPECIFIED: 0,
  CANCEL_STATUS_SUCCESS: 1,
  CANCEL_STATUS_INVITATION_NOT_FOUND: 2,
  CANCEL_STATUS_PERMISSION_DENIED: 3,
  CANCEL_STATUS_ALREADY_ACCEPTED: 4,
  CANCEL_STATUS_INTERNAL_ERROR: 5
};

/**
 * @enum {number}
 */
proto.pi_customer_public.RequestToJoinTeamStatus = {
  REQUEST_TO_JOIN_TEAM_STATUS_UNSPECIFIED: 0,
  REQUEST_SENT_SUCCESS: 1,
  CANT_REQUEST_TO_JOIN_TEAM_NOT_FOUND: 2,
  CANT_REQUEST_TO_JOIN_TEAM_ALREADY_A_MEMBER: 3,
  CANT_REQUEST_TO_JOIN_TEAM_ALREADY_REQUESTED: 4,
  CANT_REQUEST_TO_JOIN_TEAM_DOMAIN_NOT_MATCHED: 5
};

/**
 * @enum {number}
 */
proto.pi_customer_public.ResendRequestToJoinStatus = {
  RESEND_REQUEST_TO_JOIN_STATUS_UNSPECIFIED: 0,
  RESEND_REQUEST_TO_JOIN_SUCCESS: 1,
  CANT_RESEND_REQUEST_TO_JOIN_NOT_EXISTS: 2,
  CANT_RESEND_REQUEST_TO_JOIN_PERMISSION_DENIED: 3,
  CANT_RESEND_REQUEST_TO_JOIN_MISSING_REQUEST_ID: 4
};

/**
 * @enum {number}
 */
proto.pi_customer_public.CancelMyRequestToJoinTeamStatus = {
  CANCEL_MY_REQUEST_TO_JOIN_UNSPESIFIED: 0,
  CANCEL_MY_REQUEST_TO_JOIN_SUCCESS: 1,
  CANT_CANCEL_MY_REQUEST_TO_JOIN_NOT_EXISTS: 2,
  CANT_CANCEL_MY_REQUEST_TO_JOIN_PERMISSION_DENIED: 3,
  CANT_CANCEL_MY_REQUEST_TO_JOIN_MISSING_REQUEST_ID: 4
};

/**
 * @enum {number}
 */
proto.pi_customer_public.ApproveRequestToJoinTeamStatus = {
  APPROVE_REQUEST_TO_JOIN_TEAM_UNSPECIFIED: 0,
  APPROVE_REQUEST_TO_JOIN_TEAM_SUCCESS: 1,
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_NOT_EXISTS: 2,
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_INVALID_TEAM: 3,
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_AUTHORITY_TOO_HIGH: 4,
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_USER_NOT_FOUND: 5,
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_MISSING_REQUEST_ID: 6,
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_INVALID_AUTHORITY_TO_ASSIGN: 7,
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_NOT_ENOUGH_PERMISSIONS: 8,
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_ALREADY_A_MEMBER: 9,
  CANT_APPROVE_REQUEST_TO_JOIN_TEAM_MAX_USERS_REACHED: 10
};

/**
 * @enum {number}
 */
proto.pi_customer_public.DeclineRequestToJoinTeamStatus = {
  DECLINE_REQUEST_TO_JOIN_TEAM_UNSPECIFIED: 0,
  DECLINE_REQUEST_TO_JOIN_TEAM_SUCCESS: 1,
  CANT_DECLINE_REQUEST_TO_JOIN_TEAM_NOT_EXISTS: 2,
  CANT_DECLINE_REQUEST_TO_JOIN_TEAM_INVALID_TEAM: 3,
  CANT_DECLINE_REQUEST_TO_JOIN_TEAM_MISSING_REQUEST_ID: 4,
  CANT_DECLINE_REQUEST_TO_JOIN_TEAM_MOT_ENOUGH_PERMISSIONS: 5
};

/**
 * @enum {number}
 */
proto.pi_customer_public.MembershipStatus = {
  MEMBERSHIP_STATUS_UNSPECIFIED: 0,
  ACTIVE: 1,
  PENDING: 2,
  INACTIVE: 3,
  ANONYMOUS: 4,
  ACCOUNT_DELETED: 5,
  TEMPORARY_FOR_WT_SUPPORT: 6
};

/**
 * @enum {number}
 */
proto.pi_customer_public.CancelMembershipStatus = {
  CANCEL_MEMBERSHIP_UNSPECIFIED: 0,
  CANCEL_MEMBERSHIP_SUCCESS: 1,
  CANT_CANCEL_NOT_A_TEAM_OWNER: 2,
  CANT_CANCEL_NOT_ENOUGH_PERMISSIONS: 2,
  CANT_CANCEL_LAST_TEAM_ONWER: 3,
  CANT_CANCEL_MEMBERSHIP_NOT_FOUND: 4
};

/**
 * @enum {number}
 */
proto.pi_customer_public.ActivateMembershipStatus = {
  ACTIVATE_MEMBERSHIP_UNSPECIFIED: 0,
  ACTIVATE_MEMBERSHIP_SUCCESS: 1,
  CANT_ACTIVATE_NOT_A_TEAM_OWNER: 2,
  CANT_ACTIVATE_NOT_ENOUGH_PERMISSIONS: 2,
  CANT_ACTIVATE_USERS_LIMIT_REACHED: 3
};

/**
 * @enum {number}
 */
proto.pi_customer_public.ForgetTeamMemberStatus = {
  FORGET_TEAM_MEMBER_UNSPECIFIED: 0,
  FORGET_TEAM_MEMBER_SUCCESS: 1,
  CANT_FORGET_TEAM_MEMBER_NOT_A_TEAM_OWNER: 2,
  CANT_FORGET_TEAM_MEMBER_NOT_ENOUGH_PERMISSIONS: 2,
  CANT_FORGET_LAST_TEAM_OWNER: 3
};

/**
 * @enum {number}
 */
proto.pi_customer_public.ForgottenStatus = {
  FORGOTTEN_STATUS_UNSPECIFIED: 0,
  FORGOTTEN_SUCCESS: 1,
  FORGOTTEN_FAILED_MEMBERSHIP_NOT_FOUND: 2
};

/**
 * @enum {number}
 */
proto.pi_customer_public.UpdateAuthorityStatus = {
  UPDATE_AUTHORITY_UNSPECIFIED: 0,
  UPDATE_AUTHORITY_SUCCESS: 1,
  CANT_DEGRADE_NOT_A_TEAM_OWNER: 2,
  CANT_DEGRADE_LAST_TEAM_OWNER: 3,
  CANT_UPDATE_ASSIGNER_IS_MEMBER: 4,
  CANT_UPDATE_ASSIGNEE_HAS_HIGHER_AUTHORITY: 5,
  CANT_ASSIGN_HIGHER_THAN_OWN_AUTHORITY: 6,
  CANT_UPDATE_ASSIGNER_NOT_FOUND: 7,
  CANT_UPDATE_ASSIGNEE_NOT_FOUND: 8
};

goog.object.extend(exports, proto.pi_customer_public);
